{
    "401.button": "Seite neu laden",
    "401.subtitle": "Du bist nicht mehr eingeloggt, möglicherweise ist deine Sitzung abgelaufen. \n Lade die Seite neu, um dich erneut einzuloggen und fortzufahren, wo du aufgehört hast.",
    "401.title": "Zugriff verweigert",
    "403.subtitle": "Dir fehlt die Berechtigung, um diese Funktion in Unity aufzurufen. \n\n Solltest du auf einen Link zu einer Kategorien-, Tag- oder Autor:innen-Seite geklickt haben, kannst du den Link in der Vorschau des Artikels testen und den Inhalt einsehen. Um diese bearbeiten zu können, benötigst du eine andere Berechtigung. Stelle den Antrag dafür <redirectLink>über dieses Formular beim Support Hub</redirectLink>. Beim “Art der Anfrage“ wähle “Konto ändern“",
    "403.title": "Zugriff verweigert",
    "404.button": "Zurück zur Startseite",
    "404.subtitle": "Die angeforderte Seite existiert nicht.",
    "404.title": "Entschuldigung...",
    "action.copy.failure": "Kopieren vom Browser nicht unterstützt",
    "action.copy.success": "Erfolgreich kopiert!",
    "action.more": "Weitere Funktionen",
    "article.action.copyForAuthorisation.disabled.tooltip": "Bitte speichere den Artikel, bevor du den Text kopierst.",
    "article.action.copyForAuthorisation.empty": "Es gibt keinen Fliesstext oder Interview-Text zum Kopieren.",
    "article.action.copyForAuthorisation.error": "Der Text konnte nicht kopiert werden. Bitte erneut versuchen.",
    "article.action.copyForAuthorisation.success": "Text in die Zwischenablage kopiert.",
    "article.replaceBreakingnews.modal.confirmButtonText": "Breaking News ersetzen",
    "article.replaceBreakingnews.modal.message": "Dieser Artikel wird die Breaking News \"{{ title }}\" ersetzen. Der Artikel wird umgehend mit den Publikationsdaten der Breaking News publiziert. Diese Aktion kann nicht rückgängig gemacht werden.",
    "article.replaceBreakingnews.modal.title": "Breaking News ersetzen?",
    "article.replaceBreakingnews.toast.success": "Erfolgreich ersetzt",
    "article.template.autocomplete.label": "Vorlage",
    "article.template.empty.label": "Leer",
    "article.template.factcheck.label": "Faktencheck",
    "article.template.interview.label": "Interview",
    "article.template.listicle.label": "Listicle",
    "article.template.opinion.label": "Meinung",
    "article.template.reach.label": "Reach",
    "article.template.reviews.label": "Einzelkritiken",
    "article.template.standard.label": "Standard",
    "articleForm.summary.modal.cancelButtonText": "Nein, Inhalt nur speichern",
    "articleForm.summary.modal.confirmButtonText": "Ja, Zusammenfassung erstellen",
    "articleForm.summary.modal.message1": "Soll eine KI-Zusammenfassung erstellt werden?",
    "articleForm.summary.modal.message2": "Wichtig: Prüfe die Zusammenfassung nach der Erstellung und speichere den Text nochmals.",
    "articleForm.summary.modal.title": "Der Artikel enthält noch keine Zusammenfassung",
    "articles.content.external.message": "Dies ist ein externer Artikel von {{ externalSystem }} und ist schreibgeschützt.",
    "articles.content.external.title": "{{ externalSystem }} Artikel",
    "articles.list.createButton": "Artikel erstellen",
    "articles.setup.pageTitle": "Neuer Artikel",
    "articles.transformIntoTicker.button": "In Liveticker umwandeln",
    "articles.transformIntoTicker.modal.confirmationMessage": "Dieser Artikel wird in einen Liveticker umgewandelt. Alle Inhalte und Einstellungen werden übernommen. Diese Aktion kann nicht rückgängig gemacht werden.",
    "articles.transformIntoTicker.modal.confirmationTitle": "In Liveticker umwandeln?",
    "articles.transformIntoTicker.modal.confirmButtonText": "In Liveticker umwandeln",
    "articles.transformIntoTicker.toast.success": "Artikel erfolgreich umgewandelt",
    "articles.viewEditMode.areYouSure.description": "Willst du den Artikel trotzdem bearbeiten und im Anschluss die unterschiedlichen Versionen des Artikels in der Konfliktlösung zusammenführen?",
    "articles.viewEditMode.areYouSure.title": "Dieser Artikel ist bereits in Bearbeitung",
    "articles.viewEditMode.edit": "Bearbeiten",
    "articles.viewEditMode.emptyArticle": "Dieser Artikel ist noch leer. Wechsle in den Bearbeitungsmodus um mit dem Schreiben zu beginnen.",
    "articles.viewEditMode.inactive45minutes.description": "Du bist seit 45 Minuten inaktiv. Deine bisherigen Änderungen sind bereits gespeichert. Möchtest du in den Lese-Modus wechseln?",
    "articles.viewEditMode.inactive45minutes.title": "Bearbeitest du den Artikel noch?",
    "articles.viewEditMode.keepEditing": "Weiter bearbeiten",
    "articles.viewEditMode.otherUserEditing": "{{ otherUser }} bearbeitet den Artikel.",
    "articles.viewEditMode.otherUserProofreading.description": "Im Status «Korrektorat» kann nur eine Person den Artikel editieren.",
    "articles.viewEditMode.otherUserProofreading.title": "Dieser Artikel ist im Korrektorat",
    "articles.viewEditMode.otherUserSaved": "{{ otherUser }} hat eine neue Version dieses Artikels gespeichert. Du wirst zwischen den geänderten Element der neuen Version und deiner eigenen Version nach dem Speichern entscheiden müssen.",
    "articles.viewEditMode.otherUsersPresent": "Folgende Nutzer:innen editieren den Artikel bereits: ",
    "articles.viewEditMode.stayInEditMode": "Im Bearbeitungsmodus bleiben",
    "articles.viewEditMode.stayInViewMode": "In Lesemodus bleiben",
    "articles.viewEditMode.switchToEditMode": "Artikel bearbeiten",
    "articles.viewEditMode.switchToViewMode": "In Lesemodus wechseln",
    "articles.viewEditMode.unsavedChanges.description": "Deine Änderungen am Artikel sind noch nicht gespeichert. Du musst diese speichern, bevor du in den Lese-Modus wechseln kannst.",
    "articles.viewEditMode.unsavedChanges.title": "Modus-Wechsel nicht möglich",
    "articles.viewEditMode.userPresence.inactive": "Inaktiv",
    "articles.viewEditMode.userPresence.noChanges": "Keine Änderungen bisher",
    "articles.viewEditMode.userPresence.saved": "Gespeichert",
    "articles.viewEditMode.userPresence.unsavedChanges": "Nicht gespeicherte Änderungen",
    "articles.viewEditMode.view": "Lesen",
    "attachmentChooser.button": "Anhang auswählen",
    "attachmentChooser.noAttachment": "Keine Anhänge vorhanden",
    "attachmentChooser.or": "oder",
    "autocomplete.dropdown.manualOption.use": "Verwende",
    "backend.commentRiskNotSelected": "Kommentare anzeigen (Risiko)",
    "backend.emptyCategory": "Kategorie (min. 1)",
    "backend.emptyContentName": "Content Name",
    "backend.emptyEmbedCode": "Embed Code",
    "backend.emptyLead": "Lead",
    "backend.emptyMainTenantId": "Haupt-Mandant",
    "backend.emptySeoTeaserTitleLead": "SEO-Teaser-Titel/Lead",
    "backend.emptySlideCredit": "Es gibt Slides ohne Bildnachweis",
    "backend.emptyTargetDateTime": "Zieldatum und Zielzeit dürfen nicht leer sein.",
    "backend.emptyTeaserLead": "Teaser Lead",
    "backend.emptyTeaserTitle": "Teaser Titel",
    "backend.emptyTenant": "Mandant (min. 1)",
    "backend.emptyTitle": "Titel",
    "backend.emptyUrl": "URL",
    "backend.invalidTargetDateTime": "Gültige Zielzeit und Zieldatum",
    "backend.invalidTargetTextLength": "Der Text unter- oder überschreitet die vereinbarte Länge. Statuswechsel ist erst möglich, wenn die Ziellänge (+/- 150 Zeichen) eingehalten wird.",
    "backend.mainCategoryNotSyncedWithDesknet": "Die gewählte Hauptkategorie ist nicht mit Kordiam synchronisiert. Bitte eine Hauptkategorie wählen, die mit Kordiam synchronisiert ist.",
    "backend.noMainCategory": "Hauptkategorie",
    "backend.noSeoCheckDone": "Den SEO-Helper benutzen",
    "backend.noSpellCheckDone": "Die Rechtschreibprüfung benutzen",
    "backend.notSupportedTenantPresent": "Diese Funktion ist für mindestens einen Mandanten nicht verfügbar.",
    "backend.noUserNeed": "User Need Analyse starten",
    "backend.onlyOneSeriesAllowed": "Bitte wähle maximal eine Kategorie vom Typ Serie",
    "backend.unpublishedRelatedContent": "Verwandte Inhalte: In den verlinkten Inhalten sind folgende Elemente nicht publiziert und müssen somit entweder entfernt oder auf 'Publiziert' gesetzt werden: <strong>{{details}}</strong>",
    "backend.wrongArticleProofreadStatus": "Artikel Status muss auf 'A_Korrektur/A_Correction' gesetzt werden",
    "backend.wrongArticlePublicationStatus": "Artikel Status muss auf 'A_Fertig/A_Pret' gesetzt werden",
    "backend.wrongNumberOfRelatedContent": "Verwandte Inhalte (min. 3)",
    "breakingnews.detail.title": "Breaking News Inhalt",
    "breakingnews.form.body": "Body",
    "breakingnews.form.lead": "Lead",
    "breakingnews.form.title": "Titel",
    "breakingnews.form.titleHeader": "Oberzeile",
    "breakingnews.list.createButton": "Breaking News erstellen",
    "breakingnews.relatedcontent.modalTitle": "Wähle zu ersetzende Breaking News aus",
    "breakingnews.relatedcontent.submitButtonText": "Auswählen",
    "breakingnews.setup.pageTitle": "Neue Breaking News",
    "breakingnews.setupForm.modal.confirmationMessage": "Der folgende Text wird als Push-Nachricht gesendet und als Titel des Breaking News Inhalts verwendet:",
    "breakingnews.setupForm.modal.confirmationTitle": "Push-Nachricht senden und Inhalt publizieren?",
    "breakingnews.setupForm.modal.confirmButtonText": "Senden & publizieren",
    "breakingnews.setupForm.pushCategories": "Push-Kategorien",
    "breakingnews.setupForm.pushMessage": "Push-Nachricht",
    "breakingnews.setupForm.submitButton": "Senden & publizieren",
    "breakingnews.setupForm.title": "Setup und Push-Nachricht",
    "breakingnews.transformIntoTicker.button": "In Liveticker umwandeln",
    "breakingnews.transformIntoTicker.message": "Die Breaking News in einen Liveticker umwandeln, um Liveticker Einträge schreiben zu können.",
    "breakingnews.transformIntoTicker.modal.confirmationMessage": "Diese Breaking News wird in einen Liveticker umgewandelt. Alle Texte und Einstellungen werden übernommen, einschließlich des breaking news label. Diese Aktion kann nicht rückgängig gemacht werden.",
    "breakingnews.transformIntoTicker.modal.confirmationTitle": "In Liveticker umwandeln?",
    "breakingnews.transformIntoTicker.modal.confirmButtonText": "In Liveticker umwandeln",
    "breakingnews.transformIntoTicker.title": "Liveticker Einträge",
    "breakingnews.transformIntoTicker.toast.success": "Erfolgreich ersetzt",
    "browserSupportWarning": "Deine Web Browser-Version ist sehr alt. Dies kann zu Problemen bei der Nutzung von Unity CMS führen und deine allgemeine Online-Sicherheit gefährden. Bitte folge <instructionsLink>diese Schritte</instructionsLink>, um den Browser zu aktualisieren.",
    "category.edit.title": "Edit Category",
    "category.form.active": "Aktiv",
    "category.form.activeInfo": "Inaktive Kategorien können in allen Kategorienselektionen in Unity nicht mehr ausgewählt werden. Sie werden aber von Feldern, wo sie bereits selektiert sind, nicht entfernt.",
    "category.form.asyncvalidate.reject": "Der Name ist bereits vergeben",
    "category.form.confirmInactivationOfParent": "Wenn du diese Kategorie inaktivierst, werden auch alle Sub-Kategorien inaktiviert. Bist du sicher, dass du dies speichern möchtest?",
    "category.form.expiryDate": "Aktiv bis Ende",
    "category.form.modal.confirm": "Bestätigen",
    "category.form.name": "Name",
    "category.form.notFoundContent": "Kategorie nicht vorhanden",
    "category.form.parentCategory": "Übergeordnete Kategorie",
    "category.form.syncWithDesknet": "Kategorie mit Kordiam synchronisieren",
    "category.form.type": "Typ",
    "category.form.type.default": "Default",
    "category.form.type.series": "Serie",
    "category.list.createButton": "Kategorie erstellen",
    "category.list.item.expiryDatePrefix": "bis {{date}}",
    "category.list.tab.active": "Aktiv",
    "category.list.tab.all": "Alle",
    "category.list.tab.syncedWithDesknet": "Mit Kordiam synchronisiert",
    "category.name": "Name",
    "category.parentName": "Übergeordnete Kategorie",
    "category.setup.title": "Create Category",
    "category.type": "Typ",
    "collections.all": "Alle",
    "collections.categoryIds": "Beim Import diesen Kategorien zuordnen",
    "collections.edit.title": "BrixWire Stichwort bearbeiten",
    "collections.hasCategories": "Hat Kategorien zugeordnet",
    "collections.header.title": "Kollektion",
    "collections.keyword": "BrixWire Stichwort",
    "collections.noCategories": "Keine Kategorien",
    "compare.alreadyInConflictNotification": "Ups, anscheinend hat jemand eine andere Version gespeichert, während du an dieser Änderung gearbeitet hast!",
    "compare.isInConflictNotification": "Es gibt Änderungen durch eine andere Person. Diese müssen vor dem Speichern überprüft werden.",
    "compare.itemDeleted": "Objekt wurde gelöscht",
    "compare.itemNonExisting": "In dieser Version ist dieser Inhalt nicht vorhanden",
    "compare.revision.itemDeleted": "Artikel wurde in einer späteren Revision hinzugefügt",
    "compare.revision.itemNonExisting": "In dieser Revision ist dieser Inhalt nicht vorhanden",
    "conflict.headers.changes": "Änderungen",
    "conflict.headers.changes.description": "Checkbox anwählen, um Element zu speichern",
    "conflict.headers.changes.lastRevision": "letzte Revision",
    "conflict.headers.changes.yourVersion": "aktuelle Version",
    "conflict.headers.result": "Dies wird als neue Revision gespeichert",
    "conflict.headers.subtitle": "Es muss entschieden werden, welche Änderungen gespeichert und welche ignoriert werden sollen. Dazu die Kontrollkästchen auf der linken Seite klicken und dann auf Speichern.",
    "conflict.headers.subtitle.tooltip": "Frage: Warum sehe ich diesen Bildschirm? Antwort: Während an dem Inhalt gearbeitet wurde, hat jemand anderes ebenfalls Änderungen vorgenommen und gespeichert. Daher muss jetzt entschieden werden, welche der Bearbeitungen gespeichert werden sollen. Frage: Was ist jetzt zu tun? Antwort: Auf der linken Seite werden die Unterschiede gezeigt. Mit dem Kästchen neben dem Element wird ausgewählt, welches der Elemente in der neuen Revision erscheinen soll. Gespeichert werden kann erst, wenn der Entscheid für alle Elemente getroffen ist.",
    "conflict.headers.title": "Jemand anderes hat diesen Inhalt gespeichert, während der Inhalt bearbeitet wurde. Einige der Änderungen sind widersprüchlich.",
    "conflict.result.chooseMessage": "Es muss ein Element links ausgewählt werden",
    "conflict.saveButton.tooltip": "Es sind noch nicht alle Entscheidungen getroffen worden. Für jedes Element auf der linken Seite muss eine Version ausgewählt werden.",
    "content.setup.mainCategory": "Hauptkategorie",
    "content.setup.tenants": "Mandanten",
    "contentitem.bookmarkButton": "Lesezeichen hinzufügen",
    "contentitem.datePrefix.default": "Aktualisiert",
    "contentitem.deleteButton": "Löschen",
    "contentItem.deletedArticle": "Dieser Artikel wurde gelöscht. Er ist nicht mehr verfügbar und wird nicht mehr neu veröffentlicht.",
    "contentitem.editButton": "Bearbeiten",
    "contentitem.fullDatePrefix.default": "am",
    "contentItem.placeholder": "Platzhalter",
    "contentItem.placeholder.emptyText": "Momentan kein Inhalt verfügbar",
    "contentitem.placementHistoryButton": "Platzierungsverlauf",
    "contentitem.previewButton": "Vorschau",
    "contentitem.publishButton": "publizieren",
    "contentitem.publishedTimeago": "In dieser Kategorie publiziert am:",
    "contentLocaleRadioGroup": "Inhalte aus:",
    "contentLocaleRadioGroup.de-CH": "Deutschschweiz",
    "contentLocaleRadioGroup.description": "Nur Inhalte und Mandanten mit entsprechender Sprache werden sichtbar sein.",
    "contentLocaleRadioGroup.fr-CH": "Romandie",
    "contentSelection.buttonLabel": "INHALT AUSWÄHLEN",
    "contentSelection.column.createdAt": "Erstellt",
    "contentSelection.column.creator": "Ersteller",
    "contentSelection.column.edit": "Bearbeiten",
    "contentSelection.column.tenants": "Mandanten",
    "contentSelection.column.title": "Titel",
    "contentSelection.column.updatedAt": "Geändert",
    "contentSelection.contentItem.published": "Publiziert",
    "contentSelection.modal.submitButton": "Hinzufügen",
    "contentSelection.modal.title": "Inhalt auswählen",
    "contentStation.header.actions.replaceBreakingnews": "Breaking News ersetzen",
    "contentStation.header.actions.replaceBreakingnews.disabled.tooltip": "Artikel muss \"Bereit zum Publizieren\" sein",
    "contentStation.header.actions.transformArticleIntoTicker.disabled.tooltip": "Deine Änderungen am Artikel sind noch nicht gespeichert. Du musst diese speichern, bevor du den Artikel in Liveticker umwandelst.",
    "contentStatus": "Inhaltsstatus",
    "contentStatus.draft": "Entwurf",
    "contentStatus.proofread": "Korrektorat",
    "contentStatus.readyToPublish": "Fertig",
    "contentStatus.requiredRework": "Nachbearbeitung",
    "contentStatus.review1": "Gegenlesen",
    "contentStatus.review2": "Produktion",
    "contentStatus.seo": "SEO",
    "contentType.articles": "Artikel",
    "contentType.breakingnews": "Breaking news",
    "contentType.embeds": "Eingebetteter Inhalt",
    "contentType.links": "Externe Links",
    "contentType.slideshows": "Bildstrecke",
    "contentType.tickers": "Liveticker",
    "contentType.videos": "Video",
    "curatedList.abTests.filter.statuses": "Status",
    "curatedList.description": "Wähle unten einen Tab aus, um die auf deinen Anwendungsfall zugeschnittene Liste anzuzeigen. Alle Listen werden automatisch aktualisiert.",
    "curatedList.tab.abTests": "A/B Tests",
    "curatedList.tab.proofreading": "Korrektorat",
    "dataGrid.columns": "Spalten auswählen",
    "dataGrid.density": "Zeilendichte",
    "dataGrid.density.comfortable": "Komfortabel",
    "dataGrid.density.compact": "Kompakt",
    "dataGrid.density.standard": "Standard",
    "dataGrid.resetLayout": "Layout zurücksetzen",
    "editor.edit.embed.slideshow": "Edit Slideshow",
    "editor.embeddedcontent.placeholder.addButton": "Hinzufügen",
    "editor.embeddedcontent.tooltip": "Einige Inhalte könnten hier aus Sicherheitsgründen nicht angezeigt werden. Der \"Vorschau anzeigen\"-Knopf oben rechts zeigt den Inhalt an, so wie er veröffentlicht wird.",
    "editor.embedWrapperProgress.generateImageAltText": "Generiere Alt-Text...",
    "editor.embedWrapperProgress.generateThumbnail": "Generiere Vorschaubild...",
    "editor.embedWrapperProgress.uploadFile": "Lade hoch...",
    "editor.headings.tooltip": "Die Oberzeile sollte nicht länger als 30 Zeichen sein, der Titel nicht länger als 70 und der Lead nicht länger als 140. Der Lead besteht idealerweise aus zwei Sätzen.<spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1jnF7qJvfKsWOti_UiEI-v_o26zQHOBUwHoT7skMVgso/edit?usp=sharing'>Die Regeln.</linkComponent>",
    "editor.insert.embed.basicBlocks.crossheadDefault": "Zwischentitel",
    "editor.insert.embed.basicBlocks.crossheadOrderedListicle": "Listicle nummeriert",
    "editor.insert.embed.basicBlocks.crossheadSubsection": "Unterkapitel",
    "editor.insert.embed.basicBlocks.crossheadUnorderedListicle": "Listicle unnummeriert",
    "editor.insert.embed.basicBlocks.p": "Absatz",
    "editor.insert.embed.bluesky": "Bluesky embed integrieren",
    "editor.insert.embed.customJson": "Custom JSON integrieren",
    "editor.insert.embed.dynamicTeaser": "Dynamic Teaser integrieren",
    "editor.insert.embed.embeddedContent": "Eingebetteter Inhalt integrieren",
    "editor.insert.embed.embeddedSnippet": "Komponente",
    "editor.insert.embed.facebook": "Facebook embed integrieren",
    "editor.insert.embed.frontendComponent": "Interaktiv integrieren",
    "editor.insert.embed.image": "Bild einfügen",
    "editor.insert.embed.importInterview": "Import Interview",
    "editor.insert.embed.infobox": "Infobox integrieren",
    "editor.insert.embed.instagram": "Instagram embed integrieren",
    "editor.insert.embed.interviewSegment": "Interview",
    "editor.insert.embed.poll": "Poll hinzufügen",
    "editor.insert.embed.quote": "Zitat einfügen",
    "editor.insert.embed.ratingPoll": "Bewertung hinzufügen",
    "editor.insert.embed.separator": "Horizontale Linie einfügen",
    "editor.insert.embed.slideshow": "Embed Slideshow",
    "editor.insert.embed.summary": "Zusammenfassung",
    "editor.insert.embed.threads": "Threads embed integrieren",
    "editor.insert.embed.tickerSummary": "Zusammenfassung",
    "editor.insert.embed.tiktok": "TikTok embed integrieren",
    "editor.insert.embed.twitter": "X embed integrieren",
    "editor.insert.embed.videoCms": "Video CMS embed integrieren",
    "editor.insert.embed.youtube": "Youtube embed integrieren",
    "editor.insert.embed.zattoo": "Zattoo embed integrieren",
    "editor.insertToolbar.label.bluesky": "Bluesky",
    "editor.insertToolbar.label.crossheadDefault": "Zwischentitel",
    "editor.insertToolbar.label.crossheadOrderedListicle": "Listicle nummeriert",
    "editor.insertToolbar.label.crossheadSubsection": "Unterkapitel",
    "editor.insertToolbar.label.crossheadUnorderedListicle": "Listicle unnummeriert",
    "editor.insertToolbar.label.customJson": "Custom JSON",
    "editor.insertToolbar.label.dynamicTeaser": "Dynamic Teaser",
    "editor.insertToolbar.label.embeddedContent": "Inhalt",
    "editor.insertToolbar.label.embeddedSnippet": "Komponenten",
    "editor.insertToolbar.label.facebook": "Facebook",
    "editor.insertToolbar.label.footer": "Fusszeile",
    "editor.insertToolbar.label.frontendComponent": "Interaktiv",
    "editor.insertToolbar.label.img": "Bild",
    "editor.insertToolbar.label.importInterview": "Import Interview",
    "editor.insertToolbar.label.infobox": "Infobox",
    "editor.insertToolbar.label.instagram": "Instagram",
    "editor.insertToolbar.label.interviewSegment": "Interview",
    "editor.insertToolbar.label.p": "Absatz",
    "editor.insertToolbar.label.poll": "Poll",
    "editor.insertToolbar.label.quote": "Zitat",
    "editor.insertToolbar.label.ratingPoll": "Bewertung",
    "editor.insertToolbar.label.separator": "Trennlinie",
    "editor.insertToolbar.label.slideshow": "Slideshow",
    "editor.insertToolbar.label.summary": "Stichpunkte",
    "editor.insertToolbar.label.threads": "Threads",
    "editor.insertToolbar.label.tickerSummary": "Text",
    "editor.insertToolbar.label.tiktok": "TikTok",
    "editor.insertToolbar.label.twitter": "X",
    "editor.insertToolbar.label.videoCms": "Video CMS",
    "editor.insertToolbar.label.youtube": "YouTube",
    "editor.insertToolbar.label.zattoo": "Zattoo",
    "editor.insertToolbar.summary.tooltip": "Nur eine Zusammenfassung pro Inhalt kann hinzugefügt werden.",
    "editor.insertToolbar.tab.content": "Inhalt",
    "editor.insertToolbar.tab.embeds": "Eingebettet",
    "editor.plugin.a.authorLink.title": "Autor",
    "editor.plugin.a.categoryLink.title": "Kategorie",
    "editor.plugin.a.externalLink.title": "Externer Link",
    "editor.plugin.a.insert": "Link hinzufügen",
    "editor.plugin.a.internalLink.title": "Inhalt",
    "editor.plugin.a.linkDetails.editButton": "Bearbeiten",
    "editor.plugin.a.linkDetails.removeButton": "Link entfernen",
    "editor.plugin.a.modal.form.externalLink": "Externer Link",
    "editor.plugin.a.modal.form.internalLink": "Interner Link",
    "editor.plugin.a.modal.form.reference.label": "Referenz",
    "editor.plugin.a.modal.form.url.placeholder": "Link eintippen oder einfügen",
    "editor.plugin.a.modal.title": "Link hinzufügen",
    "editor.plugin.a.remove": "Link entfernen",
    "editor.plugin.a.selectTarget.button": "Ziel auswählen",
    "editor.plugin.a.selectTargetModal.authorLink.label": "Autor",
    "editor.plugin.a.selectTargetModal.categoryLink.label": "Kategorie",
    "editor.plugin.a.selectTargetModal.internalLink.label": "Inhalt",
    "editor.plugin.a.selectTargetModal.submitButton": "Hinzufügen",
    "editor.plugin.a.selectTargetModal.tagLink.label": "Tag",
    "editor.plugin.a.selectTargetModal.title": "Ziel auswählen",
    "editor.plugin.a.tagLink.title": "Tag",
    "editor.plugin.articleBuddy.approve": "Übernehmen",
    "editor.plugin.articleBuddy.category.balancedReporting.description": "Erkennt selektive Auslassungen oder Verzerrungen, die das Gesamtbild verzerren. Prüft, ob relevante Fakten fehlen oder der Kontext manipuliert wurde.",
    "editor.plugin.articleBuddy.category.balancedReporting.label": "Ausgewogene Berichterstattung",
    "editor.plugin.articleBuddy.category.chartPotential.description": "Kennzeichnet Textstellen, die sich mit einer Datawrapper-Grafik oder -Karte veranschaulichen lassen. Hierzu analysiert das Tool den Artikel auf datentaugliche Inhalte. Relevante Werte bereitet es so auf, dass du sie direkt in den Datawrapper Helper laden kannst. Fehlende Daten ergänzt es aus verlässlichen öffentlichen Quellen mit Beleg.",
    "editor.plugin.articleBuddy.category.chartPotential.label": "Grafikpotenzial",
    "editor.plugin.articleBuddy.category.clarity.description": "Markiert unerklärten Fachjargon, Abkürzungen oder fehlenden Kontext. Stellt Zugänglichkeit für ein breites Publikum sicher.",
    "editor.plugin.articleBuddy.category.clarity.label": "Klarheit",
    "editor.plugin.articleBuddy.category.conflictingSources.description": "Aussagen, denen verfügbare Quellen widersprechen. Prüfe, ob die Aussage wirklich stimmt, und formuliere sie bei Bedarf um.",
    "editor.plugin.articleBuddy.category.conflictingSources.label": "Widersprüchliche Quellen",
    "editor.plugin.articleBuddy.category.contextAndAccuracy.description": "Prüft, ob Behauptungen durch Quellen gestützt sind und ausreichend Kontext für das Verständnis liefern. Prüft auf fehlende Hintergrundinformationen oder Quellen und irreführende Darstellungen.",
    "editor.plugin.articleBuddy.category.contextAndAccuracy.label": "Kontext & Genauigkeit",
    "editor.plugin.articleBuddy.category.erase.description": "Markiert Passagen, die vollständig gestrichen werden können, ohne dass der Kern der Aussage verloren geht.",
    "editor.plugin.articleBuddy.category.erase.label": "Weglassen",
    "editor.plugin.articleBuddy.category.fairness.description": "Prüft, ob Betroffene das Recht auf Gegendarstellung hatten und die Unschuldsvermutung gewahrt wird. Kritik muss sachlich formuliert sein, ohne persönliche Angriffe oder Verleumdung.",
    "editor.plugin.articleBuddy.category.fairness.label": "Fairness",
    "editor.plugin.articleBuddy.category.genderInclusiveLanguage.description": "Prüft auf generisches Maskulinum. Empfiehlt neutrale Alternativen, respektiert aber namentlich genannte Personen.",
    "editor.plugin.articleBuddy.category.genderInclusiveLanguage.label": "Gendergerechte Sprache",
    "editor.plugin.articleBuddy.category.helvetisms.description": "Stellt die konsequente Verwendung von Schweizer Standarddeutsch sicher. Ersetzt Teutonismen durch korrekte Helvetismen.",
    "editor.plugin.articleBuddy.category.helvetisms.label": "Schweizer Deutsch",
    "editor.plugin.articleBuddy.category.independence.description": "Bewertet, ob die Berichterstattung unabhängig von PR-Einflüssen ist. Prüft auf unkritische Übernahme von Pressemitteilungen, Werbesprache oder einseitige Darstellung von Produkten ohne kritischen Kontext.",
    "editor.plugin.articleBuddy.category.independence.label": "Unabhängigkeit",
    "editor.plugin.articleBuddy.category.languageStyle.description": "Prüft auf Nominalisierungen, Passivkonstruktionen, Füllwörter, Klischees und Redundanzen. Bevorzugt aktive, prägnante Formulierungen mit starken Verben.",
    "editor.plugin.articleBuddy.category.languageStyle.label": "Sprache & Stil",
    "editor.plugin.articleBuddy.category.missingSources.description": "Aussagen, für die keine stützende Quelle gefunden wurde. Prüfe, ob die Aussage wirklich stimmt, und formuliere sie bei Bedarf um.",
    "editor.plugin.articleBuddy.category.missingSources.label": "Fehlende Quellen",
    "editor.plugin.articleBuddy.category.misspelledNames.description": "Kennzeichnet Personennamen, die falsch geschrieben scheinen, und schlägt die korrekte Schreibweise vor. Hierzu gleicht das Tool jeden Namen per Websuche mit zuverlässigen Quellen ab (z. B. Behördenseiten oder Linkedin) und berücksichtigt dabei den Kontext aus dem Artikel.",
    "editor.plugin.articleBuddy.category.misspelledNames.label": "Falsch geschriebene Namen",
    "editor.plugin.articleBuddy.category.nonDiscrimination.description": "Prüft, ob Nationalität, ethnische Zugehörigkeit, Religion oder sexuelle Orientierung nur erwähnt werden, wenn sie für die Geschichte relevant sind. Verallgemeinerungen und Stereotype sollten vermieden werden.",
    "editor.plugin.articleBuddy.category.nonDiscrimination.label": "Nicht-Diskriminierung",
    "editor.plugin.articleBuddy.category.opinionVsFact.description": "Prüft, ob Meinungen klar als solche gekennzeichnet sind und nicht als Fakten dargestellt werden.",
    "editor.plugin.articleBuddy.category.opinionVsFact.label": "Meinung vs. Tatsache",
    "editor.plugin.articleBuddy.category.paraphrase.description": "Schlägt prägnantere Formulierungen vor, die die Aussage beibehalten und die Zeichenzahl reduzieren.",
    "editor.plugin.articleBuddy.category.paraphrase.label": "Umformulieren",
    "editor.plugin.articleBuddy.category.pluralism.description": "Bewertet, ob unterschiedliche Perspektiven vertreten sind, besonders bei kontroversen Themen. Prüft auf einseitige Berichterstattung oder mangelnde Vielfalt der Stimmen.",
    "editor.plugin.articleBuddy.category.pluralism.label": "Pluralismus",
    "editor.plugin.articleBuddy.category.privacy.description": "Bewertet den Umgang mit sensiblen Informationen und privaten Details. Prüft, ob die Menschenwürde gewahrt und die Privatsphäre respektiert wird.",
    "editor.plugin.articleBuddy.category.privacy.label": "Privatsphäre",
    "editor.plugin.articleBuddy.category.punctuation.description": "Prüft den korrekten Einsatz von Doppelpunkten, Gedankenstrichen und anderen Satzzeichen. Markiert Übergebrauch oder Fehlanwendung.",
    "editor.plugin.articleBuddy.category.punctuation.label": "Interpunktion",
    "editor.plugin.articleBuddy.category.quotations.description": "Bewertet, ob Zitate Mehrwert bieten (Meinung, Emotion, Originalität). Markiert leere oder redundante Zitate, die paraphrasiert oder gestrichen werden sollten.",
    "editor.plugin.articleBuddy.category.quotations.label": "Zitate",
    "editor.plugin.articleBuddy.category.sentenceStructure.description": "Identifiziert überlange oder verschachtelte Sätze. Empfiehlt Aufteilung in klare, lesbare Einheiten.",
    "editor.plugin.articleBuddy.category.sentenceStructure.label": "Satzbau",
    "editor.plugin.articleBuddy.category.sourceTransparency.description": "Prüft, ob Quellen transparent gemacht werden und Interessenkonflikte offengelegt werden. Anonymität muss redaktionell begründet sein.",
    "editor.plugin.articleBuddy.category.sourceTransparency.label": "Quellentransparenz",
    "editor.plugin.articleBuddy.category.structureNarrativeArc.description": "Bewertet Einstieg, logischen Aufbau, Übergänge und Schluss. Markiert fehlenden roten Faden oder schwache Anfänge/Enden.",
    "editor.plugin.articleBuddy.category.structureNarrativeArc.label": "Struktur & Dramaturgie",
    "editor.plugin.articleBuddy.category.supportingSources.description": "Aussagen, die von verfügbaren Quellen bestätigt werden. Kein Handlungsbedarf.",
    "editor.plugin.articleBuddy.category.supportingSources.label": "Stützende Quellen",
    "editor.plugin.articleBuddy.category.toneLanguageRegister.description": "Prüft auf unangemessene Umgangssprache, Behördendeutsch oder parteiische Formulierungen. Stellt einen neutralen, professionellen Ton sicher.",
    "editor.plugin.articleBuddy.category.toneLanguageRegister.label": "Register",
    "editor.plugin.articleBuddy.copyReason": "Details des Vorschlags kopieren",
    "editor.plugin.articleBuddy.dismiss": "Ignorieren",
    "editor.plugin.articleBuddy.empty": "Text entfernen",
    "editor.plugin.articleBuddy.verify": "Als geprüft markieren",
    "editor.plugin.basicBlocks.apply": "Format",
    "editor.plugin.basicBlocks.crossheadDefault": "Zwischentitel",
    "editor.plugin.basicBlocks.crossheadDefault.apply": "Zwischentitel",
    "editor.plugin.basicBlocks.crossheadOrderedListicle": "Listicle nummeriert",
    "editor.plugin.basicBlocks.crossheadOrderedListicle.apply": "Listicle nummeriert",
    "editor.plugin.basicBlocks.crossheadSubsection": "Unterkapitel",
    "editor.plugin.basicBlocks.crossheadSubsection.apply": "Unterkapitel",
    "editor.plugin.basicBlocks.crossheadUnorderedListicle": "Listicle unnummeriert",
    "editor.plugin.basicBlocks.crossheadUnorderedListicle.apply": "Listicle unnummeriert",
    "editor.plugin.basicBlocks.footer": "Fusszeile",
    "editor.plugin.basicBlocks.footer.apply": "Fusszeile",
    "editor.plugin.basicBlocks.lead.placeholderText": "Lead",
    "editor.plugin.basicBlocks.p.apply": "Absatz",
    "editor.plugin.basicBlocks.title.placeholderText": "Titel",
    "editor.plugin.basicBlocks.titleHeader.placeholderText": "Oberzeile",
    "editor.plugin.blockToolbar.delete": "Löschen",
    "editor.plugin.blockToolbar.edit": "Bearbeiten",
    "editor.plugin.blockToolbar.rephrase": "Absatztext mithilfe von KI umformulieren, um deren Klarheit und Lesbarkeit zu verbessern.",
    "editor.plugin.blockToolbar.rephrase.disabledTooltip": "Ein leerer Absatztext kann nicht umformuliert werden.",
    "editor.plugin.bluesky.modal.edit": "Bluesky bearbeiten",
    "editor.plugin.bluesky.modal.insert": "Bluesky einfügen",
    "editor.plugin.bluesky.modal.submitButton": "Übernehmen",
    "editor.plugin.bluesky.title": "Bluesky",
    "editor.plugin.bold.apply": "Fett",
    "editor.plugin.comment.form.placeholder": "Kommentar erfassen...",
    "editor.plugin.comment.insert": "Kommentar erfassen",
    "editor.plugin.comment.notAvailable": "Dieser Kommentar ist nicht mehr verfügbar.",
    "editor.plugin.comment.reply.form.placeholder": "Antworten...",
    "editor.plugin.comment.resolve": "Kommentar auflösen",
    "editor.plugin.csSlideshow.modal.edit": "Slideshow bearbeiten",
    "editor.plugin.csSlideshow.modal.insert": "Slideshow einbetten",
    "editor.plugin.csSlideshow.title": "Slideshow",
    "editor.plugin.customJson.message": "Unity lädt diesen Element nicht. Er kann in der Inhaltsvorschau angezeigt werden.",
    "editor.plugin.customJson.modal.edit": "Custom JSON bearbeiten",
    "editor.plugin.customJson.modal.insert": "Custom JSON integrieren",
    "editor.plugin.customJson.modal.submitButton": "Übernehmen",
    "editor.plugin.customJson.title": "Custom JSON",
    "editor.plugin.dynamicTeaser.form.addContents": "Inhalte hinzufügen",
    "editor.plugin.dynamicTeaser.form.image": "Bild",
    "editor.plugin.dynamicTeaser.form.submitButton": "Übernehmen",
    "editor.plugin.dynamicTeaser.modal.edit": "Dynamischer Teaser bearbeiten",
    "editor.plugin.dynamicTeaser.title": "Dynamischer Teaser",
    "editor.plugin.dynamicTeaser.title.placeholder": "Titel",
    "editor.plugin.dynamicTeaser.tooltip": "Der Dynamic Teaser hat immer einen Titel, er sollte spezifisch sein und nicht «Mehr zu diesem Thema». Die Artikel sollten den Leser*innen in dieser Situation einen Mehrwert bieten. Idealerweise sollten nicht mehr als 3 Artikel hinzugefügt werden. <spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1XVjK5hdzOXZ_mM5ZENh6cjKns3kR2Bj2t6tz2HbaNks/edit?usp=sharing'>Wie wir verlinken – die Regeln.</linkComponent>",
    "editor.plugin.embed.noPlaceholder": "Keine Platzhalterinformationen gefunden für {{type}}",
    "editor.plugin.embeddedContent.modal.edit": "Eingebetteter Inhalt",
    "editor.plugin.embeddedContent.modal.submitButton": "Übernehmen",
    "editor.plugin.embeddedContent.title": "Eingebetteter Inhalt",
    "editor.plugin.embeddedContent.tooltip": "Einige Inhalte könnten hier aus Sicherheitsgründen nicht angezeigt werden. Der \"Vorschau anzeigen\"-Knopf oben rechts zeigt den Inhalt an, so wie er veröffentlicht wird.",
    "editor.plugin.embeddedSnippet.modal.edit": "Advanced",
    "editor.plugin.embeddedSnippet.modal.insert": "Komponenten",
    "editor.plugin.embeddedSnippet.title": "Baustein",
    "editor.plugin.enDash.insert": "Halbgeviertstrich",
    "editor.plugin.facebook.modal.edit": "Facebook bearbeiten",
    "editor.plugin.facebook.modal.insert": "Facebook einfügen",
    "editor.plugin.facebook.modal.submitButton": "Übernehmen",
    "editor.plugin.facebook.title": "Facebook",
    "editor.plugin.frontendComponent.form.addButton": "Eigenschaft hinzufügen",
    "editor.plugin.frontendComponent.form.removeButton": "Eigenschaft löschen",
    "editor.plugin.frontendComponent.key": "Schlüssel",
    "editor.plugin.frontendComponent.logoAlt": "Interaktiv Logo",
    "editor.plugin.frontendComponent.message": "Unity lädt diesen Element nicht. Er kann in der Inhaltsvorschau angezeigt werden.",
    "editor.plugin.frontendComponent.modal.edit": "Interaktiv bearbeiten",
    "editor.plugin.frontendComponent.modal.insert": "Interaktiv integrieren",
    "editor.plugin.frontendComponent.modal.submitButton": "Übernehmen",
    "editor.plugin.frontendComponent.title": "Interaktiv",
    "editor.plugin.frontendComponent.value": "Wert",
    "editor.plugin.guillemets.insert": "Guillemets",
    "editor.plugin.img.form.image": "Zuschneiden & Fokuspunkt",
    "editor.plugin.img.imageDescription.label": "Alt text",
    "editor.plugin.img.imageDescription.tooltip": "Dieser Alt-Text wird standardmäßig von KI generiert. Um ihn zu aktualisieren, klicke bitte auf das Bleistiftsymbol links neben dem Bild.",
    "editor.plugin.img.modal.edit": "Bild bearbeiten",
    "editor.plugin.img.modal.insert": "Bild einfügen",
    "editor.plugin.img.modal.submitButton": "Hinzufügen",
    "editor.plugin.img.modal.submitButton.editMode": "Übernehmen",
    "editor.plugin.img.title": "Bild",
    "editor.plugin.img.tooltip": "Jedes Bild braucht eine Bildunterschrift und eine Quellenangabe. Die Bildunterschrift sollte die wichtigsten Informationen über das Bild für Suchmaschinen enthalten (Wer ist auf dem Bild zu sehen? Wo und wann wurde es aufgenommen? usw.). Die Credits werden wie folgt geschrieben: Foto: Nachname, Name (Agentur). Oder: Foto: Agentur. Dasselbe gilt für Comics und Screenshots.",
    "editor.plugin.importInterview.errors": "Manche Interview-Elements sind nicht korrekt. Diese werden als normale Paragraphen importiert",
    "editor.plugin.importInterview.modal.insert": "Interview importieren",
    "editor.plugin.importInterview.parsedText": "Konvertierter Text",
    "editor.plugin.importInterview.sourceText": "Kopierter Text",
    "editor.plugin.importInterview.submitButton": "Konvertieren",
    "editor.plugin.infobox.form.collapsed": "Geschlossen",
    "editor.plugin.infobox.form.content": "Inhalt",
    "editor.plugin.infobox.form.title": "Titel",
    "editor.plugin.infobox.frame.title": "Infobox",
    "editor.plugin.infobox.modal.edit": "Infobox bearbeiten",
    "editor.plugin.infobox.modal.submitButton": "Übernehmen",
    "editor.plugin.infobox.title": "Infobox",
    "editor.plugin.infobox.tooltip": "Die Infobox muss einen Titel haben. Er sollte so konkret und beschreibend wie möglich sein. Aufzählungspunkte und Bilder sind innerhalb von Infoboxen möglich, alle anderen Elemente werden nicht angezeigt. <spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1N749NdaSZicZSiEdbcpJHfrjE0PfGZmboLcX3JYXnZ4/edit?usp=sharing'>Mehr Details zum Umgang mit Zusatzelementen.</linkComponent>",
    "editor.plugin.instagram.modal.edit": "Instagram bearbeiten",
    "editor.plugin.instagram.modal.insert": "Instagram einfügen",
    "editor.plugin.instagram.modal.submitButton": "Übernehmen",
    "editor.plugin.instagram.title": "Instagram",
    "editor.plugin.interviewSegment.answer.placeholder": "Antwort",
    "editor.plugin.interviewSegment.question.placeholder": "Frage",
    "editor.plugin.interviewSegment.title": "Interview",
    "editor.plugin.italic.apply": "Kursiv",
    "editor.plugin.ol.insert": "Nummerierte Liste",
    "editor.plugin.poll.answer.placeholder": "Antwort",
    "editor.plugin.poll.question.placeholder": "Frage",
    "editor.plugin.poll.title": "Poll",
    "editor.plugin.quote.caption.placeholder": "Autor",
    "editor.plugin.quote.text.placeholder": "Zitattext",
    "editor.plugin.quote.title": "Zitat",
    "editor.plugin.quote.tooltip": "Ein Zitat hat eine maximale Länge von 85 Zeichen. Die « und » bei direkten Zitaten werden nicht automatisch gesetzt. Wenn es sich um ein direktes Zitat handelt, sollte das Autorenfeld ausgefüllt werden und zwar wie folgt: [Vorname Name, Rolle] (in Interviews kann darauf verzichtet werden).",
    "editor.plugin.ratingPoll.form.image": "Bild",
    "editor.plugin.ratingPoll.form.name": "Name",
    "editor.plugin.ratingPoll.form.text": "Text",
    "editor.plugin.ratingPoll.modal.edit": "Bewertung bearbeiten",
    "editor.plugin.ratingPoll.modal.insert": "Bewertung einfügen",
    "editor.plugin.ratingPoll.modal.submitButton": "Hinzufügen",
    "editor.plugin.ratingPoll.modal.submitButton.editMode": "Übernehmen",
    "editor.plugin.rephrase.accept": "Neue Formulierung übernehmen",
    "editor.plugin.rephrase.diff": "Änderungen anzeigen/verbergen",
    "editor.plugin.rephrase.none": "Keine",
    "editor.plugin.rephrase.reason": "Erklärung",
    "editor.plugin.rephrase.reject": "Neue Formulierung verwerfen",
    "editor.plugin.rephrase.showLess": "Weniger anzeigen",
    "editor.plugin.rephrase.showMore": "Mehr anzeigen",
    "editor.plugin.singleGuillemets.insert": "Einfache Guillemets",
    "editor.plugin.slideshow.disabled": "Diese Slideshow wurde unpubliziert und wird deshalb nicht angezeigt.",
    "editor.plugin.slideshow.disabled.link": "Bildstrecke bearbeiten",
    "editor.plugin.slideshow.disabled.withcontentname": "Die Slideshow {{slideshowName}} wurde unpubliziert und wird deshalb nicht angezeigt.",
    "editor.plugin.slideshow.empty.link": "Bildstrecke bearbeiten",
    "editor.plugin.slideshow.empty.message": "Keine Bilder in der Bildstrecke.",
    "editor.plugin.slideshow.form.author": "Ersteller",
    "editor.plugin.slideshow.form.image": "Teaser Bild",
    "editor.plugin.slideshow.form.submitButton": "Übernehmen",
    "editor.plugin.slideshow.form.title": "Titel",
    "editor.plugin.slideshow.form.updated": "Geändert",
    "editor.plugin.slideshow.modal.edit": "Slideshow bearbeiten",
    "editor.plugin.slideshow.modal.insert": "Slideshow einbetten",
    "editor.plugin.slideshow.navigation.next": "Nächste",
    "editor.plugin.slideshow.navigation.previous": "Vorige",
    "editor.plugin.slideshow.title": "Slideshow",
    "editor.plugin.socialEmbed.securityMessage1": "Aus Sicherheitsgründen lädt Unity keine {{socialNetworkName}}-Inhalte.",
    "editor.plugin.socialEmbed.securityMessage2": "Um den Inhalt zu sehen, diesen Link klicken.",
    "editor.plugin.socialEmbed.securityMessage3": "Um zu sehen, wie der Inhalt auf der Website angezeigt wird, auf „Vorschau“ <PreviewIcon /> in der Symbolleiste oben rechts klicken.",
    "editor.plugin.softHyphen.insert": "Bedingter Trennstrich",
    "editor.plugin.specialCharacters.insert": "Sonderzeichen",
    "editor.plugin.spellChecker.advice": "Empfehlung",
    "editor.plugin.spellChecker.ignore": "Ignorieren",
    "editor.plugin.spellChecker.noAdvice": "Keine Empfehlung verfügbar.",
    "editor.plugin.spellChecker.noProposals": "Keine Vorschläge für diesen Fehler",
    "editor.plugin.spellChecker.showLess": "Weniger anzeigen",
    "editor.plugin.spellChecker.showMore": "Mehr anzeigen",
    "editor.plugin.spellChecker.suggestForDictionary": "Für das Wörterbuch vorschlagen",
    "editor.plugin.spellChecker.suggestionSubmitted": "Danke. Der Vorschlag wird vom Wörterbuchadmin überprüft.",
    "editor.plugin.spellChecker.useProposal": "Anklicken, um im Editor zu ersetzen",
    "editor.plugin.subscript.apply": "Tiefgestellt",
    "editor.plugin.subscript2.insert": "Tiefgestellte 2",
    "editor.plugin.summary.button.generate": "Vorschlag generieren",
    "editor.plugin.summary.button.generate.tooplip": "Für einen leeren Artikel kann kein Vorschlag generiert werden.",
    "editor.plugin.summary.button.replace": "Durch neuen Vorschlag ersetzen",
    "editor.plugin.summary.error": "Beim Generieren der Zusammenfassung ist ein Fehler aufgetreten.\nBitte erneut versuchen.",
    "editor.plugin.summary.ticker.button.generate": "Ticker-Zusammenfassung erstellen",
    "editor.plugin.summary.ticker.button.replace": "Durch neue Ticker-Zusammenfassung ersetzen",
    "editor.plugin.summary.ticker.longSummary": "Kontinuierlicher Ticker",
    "editor.plugin.summary.ticker.longSummaryTooltip": "Dieser Button nutzt eine optimierte KI-Anweisung, um die relevantesten und aktuellsten Einträge des Tickers auszuwählen und zusammenzufassen, die sich über mehrere Tage oder sogar länger erstrecken.",
    "editor.plugin.summary.ticker.shortSummary": "Ereignis-Ticker",
    "editor.plugin.summary.ticker.shortSummaryTooltip": "Dieser Button nutzt einen optimierten KI-Prompt, um Ereignisse mit einer Dauer von einer oder zwei Stunden zusammenzufassen, wie beispielsweise Pressekonferenzen oder Sportveranstaltungen.",
    "editor.plugin.summary.title": "Zusammenfassung",
    "editor.plugin.superscript.apply": "Hochgestellt",
    "editor.plugin.superscript2.insert": "Hochgestellte 2",
    "editor.plugin.superscript3.insert": "Hochgestellte 3",
    "editor.plugin.threads.modal.edit": "Threads bearbeiten",
    "editor.plugin.threads.modal.insert": "Threads einfügen",
    "editor.plugin.threads.modal.submitButton": "Übernehmen",
    "editor.plugin.threads.title": "Threads",
    "editor.plugin.tiktok.modal.edit": "TikTok bearbeiten",
    "editor.plugin.tiktok.modal.insert": "TikTok einfügen",
    "editor.plugin.tiktok.modal.submitButton": "Übernehmen",
    "editor.plugin.tiktok.title": "Tiktok",
    "editor.plugin.twitter.modal.edit": "Twitter bearbeiten",
    "editor.plugin.twitter.modal.insert": "Twitter einfügen",
    "editor.plugin.twitter.modal.submitButton": "Übernehmen",
    "editor.plugin.twitter.title": "X",
    "editor.plugin.ul.insert": "Aufzählung",
    "editor.plugin.underline.apply": "Unterstreichen",
    "editor.plugin.videoCms.modal.edit": "CMS Video bearbeiten",
    "editor.plugin.videoCms.modal.insert": "Video CMS embed integrieren",
    "editor.plugin.videoCms.modal.submitButton": "Übernehmen",
    "editor.plugin.videoCms.title": "Video",
    "editor.plugin.videoCms.tooltip": "Um ein Tamedia-Video anzuzeigen, ist der Unity-Embed-Code aus dem Video-CMS zu verwenden. Jedes Video braucht eine Bildunterschrift und eine Quellenangabe. Quellen werden wie folgt geschrieben: Video: Nachname, Name (Agentur). Oder: Video: Agentur.",
    "editor.plugin.youtube.modal.edit": "YouTube bearbeiten",
    "editor.plugin.youtube.modal.insert": "YouTube einfügen",
    "editor.plugin.youtube.modal.submitButton": "Übernehmen",
    "editor.plugin.youtube.title": "Youtube",
    "editor.plugin.zattoo.form.channel": "Zattoo Channel wählen",
    "editor.plugin.zattoo.modal.edit": "Zattoo",
    "editor.plugin.zattoo.modal.insert": "Zattoo embed integrieren",
    "editor.plugin.zattoo.modal.submitButton": "Übernehmen",
    "editor.plugin.zattoo.title": "Zattoo",
    "editor.stickyToolbar.counter.element": "Zeichen in Element: {{ quantity }}",
    "editor.stickyToolbar.counter.total": "Zeichen insgesamt : {{ quantity }}",
    "editor.stickyToolbar.counter.warning": "Der Text ist über 150 Zeichen länger als vereinbart. Bitte kürze den Artikel.",
    "editor.validation.titleHeader.maxLength": "Oberzeile darf maximal {{maxLength}} Zeichen lang sein",
    "editor.validation.uploading": "Speichern ist nicht möglich, solange nicht alle Elemente vollständig geladen sind.",
    "elementForm.modal.deleteMessage": "Soll die Komponente wirklich gelöscht werden? Die Komponente wird aus allen Inhalten entfernt werden.",
    "embed.captionTitle": "Legendentitel",
    "embed.code": "Embed Code",
    "embed.customJson.json": "JSON",
    "embed.fallBackHeight": "Fallback Höhe",
    "embed.frontendComponent.alt": "Content für Suchmaschinen",
    "embed.frontendComponent.label": "Label",
    "embed.frontendComponent.properties": "Eigenschaften",
    "embed.frontendComponent.source": "Skript-URL",
    "embed.iframe": "IFrame",
    "embed.iframe.preview.broken": "Das iFrame kann leider nicht dargestellt werden.",
    "embed.includeCaption": "Beschreibung hinzufügen",
    "embed.infobox.default": "Default",
    "embed.infobox.important": "Wichtig",
    "embed.infobox.summary": "Zusammenfassung",
    "embed.url": "URL",
    "embeddedcontent.iframe.error": "Diese URL funktioniert möglicherweise nicht. Sie muss in der Vorschau geprüft werden.",
    "embeddedcontent.iframe.error.500": "Der Server von Unity ist momentan nicht erreichbar. Bitte versuche es später noch einmal",
    "embeddedSnippet.component": "Komponente",
    "embeddedSnippet.copy": "Kopie einfügen",
    "embeddedSnippet.copyedit.link": "Fügt eine Kopie der ausgewählten Komponente ein, die frei bearbeitet werden kann.",
    "embeddedSnippet.copyedit.unlink": "Bindet die ausgewählte Komponente ein und hält sie mit dem Original synchron. Kann nicht bearbeitet werden.",
    "embeddedSnippet.description": "Um den Inhalt zu bearbeiten, muss die Komponente kopiert werden. Änderungen an der Kopie beeinflussen die ursprüngliche Komponente nicht.",
    "embeddedSnippet.embed": "Original einbetten",
    "embeddedSnippet.noSelection": "Wählen Sie eine Komponente aus, um die Vorschau anzuzeigen.",
    "embeddedSnippet.preview": "Vorschau",
    "emptySlideCredit": "Bildnachweis fehlt",
    "errorPage.button": "Erneut versuchen",
    "errorPage.subtitle": "Ein unerwarteter Fehler ist aufgetreten. Versuche es erneut oder wechsle auf eine andere Seite.",
    "errorPage.title": "Entschuldigung...",
    "externalcontent.embeds.actions.create": "Embedded Content erstellen",
    "externalcontent.embeds.detail.editButton": "Eingebetteter Inhalt Details bearbeiten",
    "externalcontent.embeds.detail.title": "Eingebetteter Inhalt Details",
    "externalcontent.embeds.form.lead": "Lead",
    "externalcontent.embeds.form.preview": "Vorschau",
    "externalcontent.embeds.form.title": "Titel",
    "externalcontent.embeds.form.titleHeader": "Oberzeile",
    "externalcontent.embeds.form.url": "URL",
    "externalcontent.embeds.setup.pageTitle": "Neuer eingebetteter Inhalt",
    "externalcontent.embeds.title": "Eingebettete Inhalte",
    "externalcontent.links.actions.create": "External content erstellen",
    "externalcontent.links.detail.editButton": "Externer Link Details bearbeiten",
    "externalcontent.links.detail.title": "Externer Link Details",
    "externalcontent.links.form.openinnewwindow": "In neuem Fenster öffnen",
    "externalcontent.links.form.url": "Externe URL",
    "externalcontent.links.setup.pageTitle": "Neuer Externer Link",
    "externalcontent.links.title": "Externe Links",
    "externalcontent.links.type": "Typ",
    "externalcontent.links.type.deepLink": "Deep Link",
    "externalcontent.links.type.url": "URL",
    "externalcontent.videos.detail.editButton": "Video Details bearbeiten",
    "externalcontent.videos.detail.title": "Video Details",
    "externalcontent.videos.list.createdButton": "Video erstellen",
    "externalcontent.videos.list.pageTitle": "Videos",
    "feedback.evaluation.downvote": "Runterstimmen",
    "feedback.evaluation.upvote": "Positiv bewerten",
    "fileUploadDropArea.ariaLabel": "Ablagebereich für Bilder",
    "fileUploadDropArea.criteria.description": "Nur die folgenden Dateiformate sind in den unten aufgeführten maximalen Größen zulässig:",
    "fileUploadDropArea.loading.status": "{{done}} von {{total}} {{unit}} hochgeladen ({{progress}}%)",
    "fileUploadDropArea.loading.status.bytes": "Bytes",
    "fileUploadDropArea.loading.status.files": "Dateien",
    "fileUploadDropArea.loading.title": "Lade hoch",
    "fileUploadDropArea.multiple.text": "Bilder hier ablegen um diese hochzuladen",
    "fileUploadDropArea.multiple.upload": "Bilder hochladen",
    "fileUploadDropArea.single.text": "Bild hier ablegen um dieses hochzuladen",
    "fileUploadDropArea.single.upload": "Bild hochladen",
    "form.cancelButton": "Abbrechen",
    "form.changes.restored": "Nicht gespeicherte Änderungen wiederhergestellt",
    "form.closeButton.tooltip": "Schliessen",
    "form.deleteButton": "Löschen",
    "form.fields.error": "Fehler beim Speichern. Bitte überprüfe deine Eingaben.",
    "form.fields.urlIframe.placeholder": "URL oder iframe (https)",
    "form.modal.cancelMessage": "Bist du sicher, dass du abbrechen möchtest? Vorgenommene Änderungen werden verworfen.",
    "form.modal.cancelTitle": "Abbrechen",
    "form.modal.deleteMessage": "Bist du sicher, dass du dieses Element löschen möchtest?",
    "form.modal.deleteTitle": "Löschen",
    "form.stepInput.decrease": "verringern",
    "form.stepInput.increase": "erhöhen",
    "form.submitButton": "Speichern",
    "geneeaEntitiesAutocomplete.noneFound": "Keine Entitäten gefunden",
    "geneeaEntityForm.assignTag.hint": "Sobald du einen Tag zuweist, erscheinen Artikel, die mit dieser Entität markiert sind, automatisch auf der Seite dieses Tags. Die obige Dropdown-Liste zeigt nur Entitäten an, denen noch keine Tags zugewiesen wurden.",
    "geneeaEntityForm.assignTag.label": "Tag",
    "geneeaEntityForm.assignTag.title": "Bestehenden Tag zuweisen",
    "geneeaEntityForm.createTag.form.active": "Aktiv",
    "geneeaEntityForm.createTag.form.allowRobots": "In den Suchmaschinen anzeigen",
    "geneeaEntityForm.createTag.form.asyncvalidate.reject": "Der Name ist bereits vergeben",
    "geneeaEntityForm.createTag.form.description": "Beschreibung",
    "geneeaEntityForm.createTag.form.geneeaEntity.hint": "Mit dieser Entität markierte Artikel erscheinen automatisch auf der Seite dieses Tags. Wenn du das nicht möchtest, entferne die Entität oben und speichere die Änderungen.",
    "geneeaEntityForm.createTag.form.geneeaEntity.label": "Zugewiesene Entität",
    "geneeaEntityForm.createTag.form.image": "Bild",
    "geneeaEntityForm.createTag.form.name": "Name",
    "geneeaEntityForm.createTag.form.title": "Titel",
    "geneeaEntityForm.createTag.title": "Neuen Tag erstellen",
    "geneeaEntityForm.or": "oder",
    "geneeaEntityList.filter.all": "Alle",
    "geneeaEntityList.filter.assigned": "Tag zugewiesen",
    "geneeaEntityList.filter.unassigned": "Kein Tag",
    "geneeaEntityList.name": "Name",
    "geneeaEntityList.tag": "Zugewiesener Tag",
    "geneeaEntityList.totalCount": "Anz. Artikel",
    "geneeaEntityList.type": "Typ",
    "home.title.greetings": "wie geht es dir heute?",
    "home.title.hello": "Hallo {{name}},",
    "home.widget.releaseNotes": "Release note",
    "home.widget.relevantSystems": "Relevante Systeme",
    "icon.pin.title": "Pin",
    "image.caption": "Bildtext",
    "image.credit": "Bildnachweis",
    "image.description": "Bildbeschreibung",
    "image.focusPoint.title": "Fokuspunkt",
    "image.style.image": "Image",
    "image.style.infographic": "Graphic",
    "kickword.edit.title": "Kickword bearbeiten",
    "kickword.form.asyncvalidate.reject": "Dieser Name ist bereits vergeben",
    "kickword.form.color.background": "Hintergrundfarbe",
    "kickword.form.color.border": "Rahmenfarbe",
    "kickword.form.color.placeholder": "Hex-Farbcode (z. B. #DDEE55)",
    "kickword.form.color.text": "Schriftfarbe",
    "kickword.form.name": "Name",
    "kickword.list.addButton": "Kickword erstellen",
    "kickword.setup.title": "Kickword erstellen",
    "kickword.title": "Kickwords",
    "league.edit.title": "Liga oder Turnier bearbeiten",
    "league.form.nameEnglish": "Name der Liga oder des Turniers (Englisch)",
    "league.form.nameFrench": "Name der Liga oder des Turniers (Französisch)",
    "league.form.nameGerman": "Name der Liga oder des Turniers (Deutsch)",
    "league.form.radio.item.iceHockey": "Eishockey",
    "league.form.radio.item.soccer": "Fussball",
    "league.form.radio.title.sport": "Sport",
    "league.setup.title": "Liga oder Turnier erstellen",
    "list.noresult": "Keine Suchergebnisse gefunden",
    "maintenancenotes.form.note": "Hinweis hinzufügen (Startseite)",
    "maintenancenotes.form.notification": "Hinweis hinzufügen (Benachrichtigungsleiste)",
    "maintenancenotes.form.status": "Status",
    "maintenancenotes.form.title": "Hinweis zur Wartung",
    "maintenancenotes.status.available": "Verfügbar",
    "maintenancenotes.status.maintenance": "Wartung",
    "maintenancenotes.title": "Unity Systemstatus",
    "metadata.action.copy.success": "ID wurde erfolgreich kopiert!",
    "metadata.users.minCharacters": "Bitte mindestens 2 Zeichen eingeben",
    "metadata.users.nonefound": "Keine Nutzer gefunden",
    "metadataHistory.closeButton.title": "Schliessen",
    "metadataHistory.contentStatus": "Inhaltsstatus",
    "metadataHistory.fieldName": "Feldname",
    "metadataHistory.newValue": "Neuer Wert",
    "metadataHistory.operation": "Operation",
    "metadataHistory.operation.added": "Hinzugefügt",
    "metadataHistory.operation.removed": "Entfernt",
    "metadataHistory.operation.updated": "Aktualisiert",
    "metadataHistory.publicationStatus": "Publikationsstatus",
    "metadataHistory.tenant": "Mandant",
    "metadataHistory.tenant.default": "Default",
    "metadataHistory.title": "Metadatenverlauf",
    "metadataHistory.updated": "Geändert",
    "metadataHistory.updatedBy": "Geändert von",
    "metadataHistory.value.off": "AUS",
    "metadataHistory.value.on": "AN",
    "metadataHistory.value.placeholder": "Kann hier nicht angezeigt werden",
    "metaform.additionalsettings.adsEnabled": "Ads anzeigen",
    "metaform.additionalsettings.aiGenerated": "KI-generiert",
    "metaform.additionalsettings.allowRobots": "In den Suchmaschinen anzeigen",
    "metaform.additionalsettings.authorBiographyDisplayed": "Biografie anzeigen",
    "metaform.additionalsettings.breakingNews": "Breaking News",
    "metaform.additionalsettings.commentingEnabled": "Kommentare anzeigen",
    "metaform.additionalsettings.commentRisk": "Comment risk",
    "metaform.additionalsettings.commentRisk.high": "Hohes Risiko",
    "metaform.additionalsettings.commentRisk.low": "Geringes Risiko",
    "metaform.additionalsettings.confirmDisableAds.content": "Bist du sicher, dass du die Werbung deaktivieren möchtest?",
    "metaform.additionalsettings.confirmDisableAds.title": "Werbung deaktivieren",
    "metaform.additionalsettings.contest": "Wettbewerb",
    "metaform.additionalsettings.feedbackEnabled": "Feedback anzeigen",
    "metaform.additionalsettings.group1": "Contenttyp",
    "metaform.additionalsettings.group2": "Contentanzeige",
    "metaform.additionalsettings.headDisabled": "Ohne Header",
    "metaform.additionalsettings.likesEnabled": "Likes anzeigen",
    "metaform.additionalsettings.live": "Live",
    "metaform.additionalsettings.newsletterSubscribingEnabled": "Newsletter-Abonnierung anzeigen",
    "metaform.additionalsettings.opinion": "Meinung",
    "metaform.additionalSettings.opinion.tooltip": "Dieser Schalter weist den Artikel als Meinung aus. Bitte wählt mit Hilfe des Dropdown-Menüs die Art des Meinungsbeitrages aus.",
    "metaform.additionalsettings.opinionType": "Meinungstyp",
    "metaform.additionalsettings.podcast": "Podcast",
    "metaform.additionalsettings.premium": "Premium",
    "metaform.additionalsettings.publicationDateExposed": "Datum anzeigen",
    "metaform.additionalsettings.readAloudEnabled": "Vorlesefunktion anzeigen",
    "metaform.additionalsettings.renderedInWebView": "App: In Web-View anzeigen",
    "metaform.additionalsettings.sharingEnabled": "Sharing anzeigen",
    "metaform.additionalsettings.syndication": "Syndikation",
    "metaform.additionalsettings.title": "Erweiterte Einstellungen",
    "metaform.additionalsettings.translation": "Übersetzung",
    "metaform.additionalsettings.videoInContent": "Video",
    "metaform.additionalsettings.visibleInNewestContent": "In neuesten Inhalten anzeigen",
    "metaform.authors.addButton": "Hinzufügen",
    "metaform.authors.additionalInfo": "Weitere Infos",
    "metaform.authors.agency": "Agentur",
    "metaform.authors.author": "Autor",
    "metaform.authors.contributor": "Mitwirkend",
    "metaform.authors.name": "Name",
    "metaform.authors.photographer": "Fotograf",
    "metaform.authors.removeButton": "Löschen",
    "metaform.authors.service": "Service",
    "metaform.authors.title": "Autoren",
    "metaform.authors.title.tooltip": "Hier werden alle Autor*innen des Artikels erfasst. Um eine*n Autor*in nicht in der Byline anzuzeigen, ihn aber dennoch für ProLitteris zu erfassen, kann der Typ «Mitwirkend» verwendet werden. Wenn eine Agentur hinzugefügt wird, wird nur das Autor*innen-Kürzel angezeigt. Autor*innen ohne Dropdown-Eintrag können als Externe hinzugefügt werden. Um externe Autor*innen hinzuzufügen, ist das Produkt-Team über folgenden Slack-Channel zu kontaktieren: #helpline_disco. <spacer /> <linkIcon /> <linkComponent href='https://tamedia.slack.com/archives/CTGHWRT3K'>Link</linkComponent",
    "metaform.authors.type": "Typ",
    "metaform.category.notFoundContent": "Keine Suchergebnisse gefunden",
    "metaform.emailAlerts.label": "E-Mail-Benachrichtigungen aktivieren",
    "metaform.emailAlerts.tooltip.alreadyEnabled": "E-Mail-Benachrichtigungen aktiviert. Sie können nicht mehr deaktiviert werden.",
    "metaform.emailAlerts.tooltip.disabled": "Für den Versand einer E-Mail-Benachrichtigung muss mindestens ein Tag ausgewählt werden. Benachrichtigungen können nur einmal pro Ticker versendet werden.",
    "metaform.fixedmenubar.metadataHistory": "Metadatenverlauf",
    "metaform.fixedmenubar.placementHistory": "Platzierungsverlauf",
    "metaform.fixedmenubar.preview": "Vorschau anzeigen",
    "metaform.fixedmenubar.restore": "Wiederherstellen",
    "metaform.fixedmenubar.save": "Änderungen speichern",
    "metaform.hreflang.addButton": "Hinzufügen",
    "metaform.hreflang.title": "Hreflang",
    "metaform.hreflang.title.tooltip": "Die hier konfigurierten Hreflang-Tags werden zusammen mit den übrigen Metadaten des Artikels auf der Website ausgeliefert. Jede Zeile definiert eine Locale (eine Kombination aus Region und Sprache) und eine URL. Suchmaschinen verwenden diese Daten, um in den Suchergebnissen eine URL anzuzeigen, die zum aktuellen Standort und zur Sprache der Nutzer:innen passt.",
    "metaform.infobox.button": "Infobox hinzufügen",
    "metaform.infobox.field.content": "Inhalt",
    "metaform.infobox.field.title": "Titel",
    "metaform.infobox.item.editButton": "Infobox bearbeiten",
    "metaform.infobox.modal.title": "Infobox",
    "metaform.infobox.title": "Infobox",
    "metaform.infobox.title.tooltip": "Diese Infobox wird immer am Ende des Artikels mit einem grauen Hintergrund und aufgeklappt angezeigt. Innerhalb dieser Infobox können alle Komponenten und Elemente verwendet werden. Der Titel ist optional.",
    "metaform.kickword.nonefound": "Keine weiteren Kickwords verfügbar",
    "metaform.kickword.placeholder": "Kickword auswählen",
    "metaform.modal.confirm": "Bestätigen",
    "metaform.note.placeholder": "Notiz einfügen",
    "metaform.note.title": "Notiz",
    "metaform.note.title.tooltip": "Dieses Notizfeld ist nur für den internen Gebrauch. Zum Beispiel für Bemerkungen, wenn ein Inhalt offline genommen wird oder für temporäre Kommentare ans Korrektorat oder vom Korrektorat. Die Notizen werden nirgends öffentlich angezeigt.",
    "metaform.placement.categories": "Kategorien",
    "metaform.placement.categories.placeholder": "Kategorien auswählen...",
    "metaform.placement.categories.tooltip": "Der Artikel wird in jeder gewählten Kategorie platziert, wobei die Hauptkategorie die passendste sein sollte. Sie ist wichtig für die Automatisierung, Kampagnen, Tracking und wird in der Navigation hervorgehoben.",
    "metaform.placement.editorialOrigin": "Redaktionelle Herkunft",
    "metaform.placement.editorialOrigin.agency": "Agentur",
    "metaform.placement.editorialOrigin.mantel": "Mantel",
    "metaform.placement.editorialOrigin.mantel_reach": "Mantel + Reach",
    "metaform.placement.editorialOrigin.national": "National",
    "metaform.placement.editorialOrigin.reach": "Reach",
    "metaform.placement.editorialOrigin.regional": "Regional",
    "metaform.placement.editorialOrigin.regional_reach": "Regional + Reach",
    "metaform.placement.editorialOrigin.tooltip": "Die Unterscheidung ist für Datenauswertungen wichtig. Beispiel für die Auswahl: Texte aus der Redaktionen der BaZ, BZ oder vom Bund erhalten die Kategorie «Regional». Texte aus den Lokal-Ressorts des Tages-Anzeigers erhalten ebenfalls «Regional». Artikel aus beispielsweise dem Ressort Inland, die für alle Titel erstellt werden, erhalten «Mantel». Nachrichtenmeldungen der SDA, DPA oder AFP, die von BrixWire importiert werden, erhalten «Agentur». Alle Texte aus dem Reach-Bereich, die nicht auf Agenturen beruhen, erhalten die Kategorie «Reach».",
    "metaform.placement.mainCategory": "Hauptkategorie",
    "metaform.placement.mainCategory.placeholder": "Hauptkategorie auswählen...",
    "metaform.placement.tenantTitle": "Mandanten",
    "metaform.placement.tenantTitle.tooltip": "Der Artikel wird für alle ausgewählten Titel veröffentlicht. Der Hauptmandant ist wichtig für die Suchmaschinen-Optimierung, er muss ausgewählt werden.",
    "metaform.placement.title": "Platzierung",
    "metaform.pollSettings.label": "Abstimmung bei Polls und Bewertungen aktiv",
    "metaform.pollSettings.title": "Polls und Bewertungen",
    "metaform.pollSettings.tooltip": "Solange der Schalter unten aktiviert ist, können Nutzer bei allen Sternebewertungen und Polls in diesem Inhalt abstimmen. Sobald er deaktiviert ist, werden nur noch die Ergebnisse angezeigt, eine Abstimmung ist aber nicht mehr möglich.",
    "metaform.printMetadata.category": "Kategorie",
    "metaform.printMetadata.desknetEntry": "Kordiam Thema",
    "metaform.printMetadata.desknetEntryLink": "Kordiam Thema Link",
    "metaform.printMetadata.desknetSync": "Synchronisation zu Kordiam aktivieren",
    "metaform.printMetadata.desknetSyncDisabled": "Synchronisation zu Kordiam aktiviert",
    "metaform.printMetadata.desknetToolTip": "Beim Anklicken dieses Knopfes wird Synchronisation dieses Inhalts zu Kordiam aktiviert. Einmal eingeschaltet, kann es nicht mehr ausgeschaltet werden.",
    "metaform.printMetadata.desknetToolTipDisabled": "Die Synchronisierung mit Kordiam wurde eingeschaltet. Sie kann nicht mehr ausgeschaltet werden.",
    "metaform.printMetadata.pageName": "Seitenname",
    "metaform.printMetadata.publication": "Publikation",
    "metaform.printMetadata.publicationTargetDate": "Zieldatum der Veröffentlichung",
    "metaform.printMetadata.studioDossierId": "Dossier ID",
    "metaform.printMetadata.studioDossierLink": "Dossier Link",
    "metaform.printMetadata.studioStatus": "Print Status",
    "metaform.printMetadata.studioSync": "Synchronisation zu WW Studio aktivieren",
    "metaform.printMetadata.studioSyncDisabled": "Synchronisation zu WW Studio aktiviert",
    "metaform.printMetadata.studioToolTip": "Beim Anklicken dieses Knopfes wird Synchronisation dieses Inhalts zu WW Studio aktiviert. Einmal eingeschaltet, kann es nicht mehr ausgeschaltet werden.",
    "metaform.printMetadata.studioToolTipDisabled": "Die Synchronisation zu WW Studio wurde eingeschaltet. Sie kann nicht mehr ausgeschaltet werden.",
    "metaform.printMetadata.targetDateTime": "Zielzeit und Zieldatum",
    "metaform.printMetadata.targetDateTime.tooltip": "Das Zieldatum und der Slot steuern die Reihenfolge, in welcher die Produktion und das Korrektorat die Inhalte lesen. Der Zeitpunkt wird vom Online-Publikationsdatum in Kordiam bestimmt.",
    "metaform.printMetadata.title": "Integration mit Print und Planung",
    "metaform.printMetadata.type": "Typ",
    "metaform.pushform.categories": "Kategorien",
    "metaform.pushform.message.title": "Nachricht",
    "metaform.pushform.modal.confirm": "Bestätigen",
    "metaform.pushform.send": "Senden",
    "metaform.pushform.send.confirmationMessage": "Bist du sicher, dass du diese Nachricht senden möchtest?",
    "metaform.pushform.send.disabled": "Bitte stelle sicher, dass der Inhalt bereits publiziert ist",
    "metaform.pushform.tenants": "Mandanten",
    "metaform.pushform.title": "Push-Nachrichten",
    "metaform.pushHistory.createdAt": "Gesendet an",
    "metaform.pushHistory.pushText": "Nachricht",
    "metaform.pushHistory.refresh": "Status aktualisieren",
    "metaform.pushHistory.title": "Nachrichtenverlauf",
    "metaform.scheduledPlacing.customUpdatedAtError": "Der Aktualisierungszeitpunkt muss nach dem Publikationszeitpunkt liegen",
    "metaform.scheduledPlacing.error.required": "Publikationszeitpunkt oder Ablaufzeitpunkt ist erforderlich",
    "metaform.scheduledPlacing.expiryTime": "Ablaufzeitpunkt",
    "metaform.scheduledPlacing.expiryTimeError": "Der Ablaufzeitpunkt muss nach dem Publikationszeitpunkt liegen",
    "metaform.scheduledPlacing.on": "Zeitgesteuerte Publikation",
    "metaform.scheduledPlacing.publicationTime": "Publikationszeitpunkt",
    "metaform.scheduledPlacing.publishedOn": "Publiziert am",
    "metaform.scheduledPlacing.targetDateRequired": "Zieldatum ist erforderlich",
    "metaform.scheduledPlacing.targetTextLength": "Vereinbarte Textlänge",
    "metaform.scheduledPlacing.targetTimeRequired": "Zeitfenster ist erforderlich",
    "metaform.scheduledPlacing.targetUserNeed": "Vereinbarter User Need",
    "metaform.scheduledPlacing.title": "Planung",
    "metaform.scheduledPlacing.updatedNow": "Jetzt aktualisieren",
    "metaform.scheduledPlacing.updatedOn": "Aktualisiert am",
    "metaform.seoTeaser.button.generate": "SEO-Teaser generieren",
    "metaform.seoTeaser.button.generate.tooltip": "Für einen leeren Artikel kann kein SEO-Teaser generiert werden.",
    "metaform.seoTeaser.keywords.button.copy": "Vom default Teaser kopieren",
    "metaform.seoTeaser.keywords.button.error": "Beim Generieren der Keywords ist ein Fehler aufgetreten. Bitte erneut versuchen.",
    "metaform.seoTeaser.keywords.button.generate": "Keywords und SEO-Teaser generieren",
    "metaform.seoTeaser.keywords.button.generate.tooltip": "Für einen leeren Artikel können keine Keywords generiert werden.",
    "metaform.seoTeaser.keywords.emptyKeyWords": "SEO-Teaser-Titel ist noch leer. Hier klicken, um ihn zu ergänzen. Oder den Button anklicken um den Text und Keywords zu generieren. Diese werden automatisch generiert, sobald die vereinbarte Länge erreicht ist.",
    "metaform.seoTeaser.keywords.title": "Keyword-Vorschläge",
    "metaform.seoTeaser.keywords.tooltip": "Es müssen nicht alle von ChatGPT vorgeschlagenen Keywords benutzt werden. Wichtig: Setze das wichtigste Keyword möglichst an den Anfang. Mehr Infos und Tipps im <spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1Sh6W2je2E6AMtUXLhNG86atksInlTNkGYdnMdWMnMlQ/'>SEO Handbuch.</linkComponent>",
    "metaform.seoTeaser.modal.lead.tooltip": "Der SEO-Lead darf nicht länger als 140 Zeichen sein und sollte mit den wichtigsten Keywords beginnen. Er muss vor der Publikation bearbeitet werden.",
    "metaform.seoTeaser.modal.title.tooltip": "Der SEO-Titel muss einzigartig sein, darf nicht länger als 60 Zeichen sein und zwingend mit den wichtigsten Keywords beginnen. Er muss vor der Publikation bearbeitet werden.",
    "metaform.seoTeaser.title": "SEO-Teaser",
    "metaform.specialTeaser.button.generate": "Special-Teaser generieren",
    "metaform.specialTeaser.button.generate.tooltip": "Für einen leeren Artikel kann kein Special-Teaser generiert werden.",
    "metaform.style.title": "Stil",
    "metaform.styles.backgroundstory": "Background Story volle Breite",
    "metaform.styles.backgroundstorywithads": "Background Story",
    "metaform.styles.commentary": "Meinungsteaser mit Autorenbild",
    "metaform.styles.default": "Default",
    "metaform.styles.focus": "Focus",
    "metaform.styles.fullwidth": "Volle Breite",
    "metaform.styles.label": "Stile",
    "metaform.styles.newsbriefing": "Newsbriefing",
    "metaform.styles.notFoundContent": "Keine Suchergebnisse gefunden",
    "metaform.styles.visual": "Visual",
    "metaform.tags.nonefound": "Keine weiteren Tags verfügbar",
    "metaform.tags.placeholder": "Passende Tags auswählen",
    "metaform.tags.title": "Tags",
    "metaform.tags.title.tooltip": "Die News-Titel benutzen Tags nur für Gemeinden oder Formate. Unternehmen-Tags werden nur von «Finanz und Wirtschaft» verwendet.<spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1JARnbQhWRXezKZiMv3WJ9vBgQRPnLU9QdqGbzeWrCsw/edit#heading=h.i84iej120vmb'>Die Regeln dazu.</linkComponent>",
    "metaform.teaser.abtest.betaFeature": "Derzeit nur für Beta-Tester verfügbar.",
    "metaform.teaser.abtest.results.significance.notSignificant": "Nicht signifikant",
    "metaform.teaser.abtest.results.significance.significant": "Signifikant",
    "metaform.teaser.abtest.results.significance.tooltip": "Die drei möglichen Werte sind: sehr signifikant (p-Wert unter 0,01 oder gleich), signifikant (p zwischen 0,01 und 0,05) und nicht signifikant (p größer als 0,05).",
    "metaform.teaser.abtest.results.significance.verySignificant": "Sehr signifikant",
    "metaform.teaser.abtest.status": "A/B Test status",
    "metaform.teaser.abtest.status.completed": "Durchgeführt",
    "metaform.teaser.abtest.status.initialized": "Erstellt",
    "metaform.teaser.abtest.status.running": "Gestartet",
    "metaform.teaser.abtest.status.stopped": "Abgebrochen",
    "metaform.teaser.abtest.versionA": "Version A",
    "metaform.teaser.abtest.versionA.edit": "Teaser Version A bearbeiten",
    "metaform.teaser.abtest.versionB": "Version B",
    "metaform.teaser.abtest.versionB.cancel": "A/B Test abbrechen",
    "metaform.teaser.abtest.versionB.cancel.confirm": "Bist du sicher, dass du den Test abbrechen möchtest? Dies wird die Version B und alle Resultate entfernen. Du wirst einen neuen Test starten können.",
    "metaform.teaser.abtest.versionB.create": "A/B Test erstellen",
    "metaform.teaser.abtest.versionB.edit": "Teaser Version B bearbeiten",
    "metaform.teaser.abtest.versionB.form.description": "Um den A/B Test zu starten, aktualisiere die B-Version hier. Die A-Version ist bereits auf Basis des Standard-Teasers erstellt. Der Test startet, wenn du die Änderungen speicherst,  den Artikel publizierst und ihn in mindestens einer der Kategorie platzierst, wo A/B tests freigegeben sind. Nach 10 Minuten wird die Version mit den meisten Klicks automatisch als neuer Standard-Teaser festgelegt.",
    "metaform.teaser.abtest.versionB.remove": "Version B entfernen",
    "metaform.teaser.abtest.versionB.remove.confirm": "Bist du sicher, dass du die Teaser-Version B entfernen möchtest? Du wirst eine neue erstellen können.",
    "metaform.teaser.abtest.versionB.results.clicks": "Klicks",
    "metaform.teaser.abtest.versionB.seeResults": "Testergebnisse ansehen",
    "metaform.teaser.abtest.versionB.status.completed": "A/B test {{timestamp}} durchgeführt",
    "metaform.teaser.abtest.versionB.status.initialized": "Der Test startet, wenn du die Änderungen speicherst, den Artikel publizierst und ihn in mindestens einer der Kategorie platzierst, wo A/B tests freigegeben sind.",
    "metaform.teaser.abtest.versionB.status.running": "A/B test {{timestamp}} gestartet. Um die Teaser zu aktualisieren, erst den Test abbrechen. Derzeit nur für Beta-Tester verfügbar.",
    "metaform.teaser.abtest.versionB.tooltip.disabled": "A/B Test kann nicht erstellt werden, wenn Teaservarianten vorhanden sind oder der Teaser leer ist. Entferne die Varianten oder fülle den Teaser aus, um einen Test zu erstellen. Derzeit nur für Beta-Tester verfügbar.",
    "metaform.teaser.abtest.versionB.tooltip.testRunning": "Teaservarianten können während eines A/B Tests nicht erstellt werden",
    "metaform.teaser.allowAutomaticUpdate": "Inhalte automatisch synchronisieren",
    "metaform.teaser.emptyDescription": "Bildbeschreibung ist noch leer. Oben auf den Teaser klicken, um ihn zu ergänzen.",
    "metaform.teaser.imageDescription.size.error": "Teaser > Bildbeschreibung darf maximal 1000 Zeichen lang sein",
    "metaform.teaser.imageDescription.tooltip": "Der Alt-Text soll präzise und knapp den Bildinhalt beschreiben, identifizierbare Personen und Orte nennen sowie relevante SEO-Schlüsselwörter enthalten. Max. 150 Zeichen. Beispiel: Präsidentschaftskandidatin Kamala Harris spricht an einer Wahlkampfveranstaltung in Detroit (USA) über Donald Trump.<spacer /> Mehr Tipps: <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1Sh6W2je2E6AMtUXLhNG86atksInlTNkGYdnMdWMnMlQ/'>SEO-Handbuch.</linkComponent> ",
    "metaform.teaser.modal": "Teaser bearbeiten",
    "metaform.teaser.modal.adoptdefaults": "Vom Standard teaser synchronisieren",
    "metaform.teaser.modal.adoptdefaults.tooltip": "Ist das Teaserbild leer, wird es immer synchronisiert und nicht durch diesen Schalter gesteuert.",
    "metaform.teaser.modal.defaultTeaserRadio": "Standard Teaser",
    "metaform.teaser.modal.deleteimage": "Bild löschen",
    "metaform.teaser.modal.embeddedContentRadio": "Eingebetteter Inhalt",
    "metaform.teaser.modal.embedUrl": "Embed URL",
    "metaform.teaser.modal.image": "Bild",
    "metaform.teaser.modal.lead": "Lead",
    "metaform.teaser.modal.lead.tooltip": "Der Lead sollte nicht länger als 180 Zeichen sein.",
    "metaform.teaser.modal.preview.1:1": "Opener Mobile, Regular, Card (1:1)",
    "metaform.teaser.modal.preview.16:9": "Opener Desktop (16:9)",
    "metaform.teaser.modal.preview.2:1": "2:1",
    "metaform.teaser.modal.preview.3:2": "Panorama (3:2)",
    "metaform.teaser.modal.preview.animated": "Dies ist ein animiertes Bild und kann nicht zugeschnitten werden",
    "metaform.teaser.modal.preview.title": "Teaserbild-Vorschau",
    "metaform.teaser.modal.refreshDescription": "Bildbeschreibung neu generieren",
    "metaform.teaser.modal.title": "Titel",
    "metaform.teaser.modal.title.tooltip": "Der Titel sollte nicht länger als 80 Zeichen sein.",
    "metaform.teaser.modal.titleHeader": "Oberzeile",
    "metaform.teaser.modal.titleHeader.tooltip": "Die Oberzeile sollte nicht länger als 30 Zeichen sein.",
    "metaform.teaser.modal.uploadimage": "Bild hochladen",
    "metaform.teaser.special.tooltip": "Dieser Teaser ist der Open Graph (OG Title). Der Teaser wird für alle Sozialen Netzwerke benutzt. Er wird zudem auf Google Discover angezeigt. <spacer /> Mehr Infos <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1Sh6W2je2E6AMtUXLhNG86atksInlTNkGYdnMdWMnMlQ/'>SEO Handbuch.</linkComponent>",
    "metaform.teaser.title": "Teaser",
    "metaform.teaser.type.default": "Default teaser",
    "metaform.teaser.type.opengraph": "Spezial-Teaser",
    "metaform.url.description": "Teil der URL, der den Inhalt beschreibt. Erlaubte Zeichen sind a-z, 0-9 and -.",
    "metaform.url.editButton": "URL slug bearbeiten",
    "metaform.url.example": "Beispiel: ",
    "metaform.url.title": "URL-Slug",
    "metaform.validation.modal.adjust.description": "Um diesen Status oder die zeitgesteuerte Publikation zu verändern, müssen diese Felder angepasst werden:",
    "metaform.validation.modal.description": "Um diesen Status oder die zeitgesteuerte Publikation zu setzen, müssen diese Felder angepasst werden:",
    "metaform.validation.modal.title": "Erforderliche Felder",
    "metaform.validation.unpublishModal.description": "Bist du sicher, dass du diesen Inhalt nicht mehr publiziert haben möchtest?",
    "modal.cancelButton": "Abbrechen",
    "modal.cloneContent.title": "Inhalt klonen",
    "modal.confirmButton": "Ok",
    "modal.deleteButton": "Löschen",
    "modal.deleteContent.message": "Bist du sicher, dass du dieses Element löschen möchtest?",
    "modal.deleteContent.title": "Löschen",
    "modal.duplicateContent.content": "Bist du sicher, dass du diesen Inhalt duplizieren möchtest?",
    "modal.duplicateContent.title": "Inhalt duplizieren",
    "navigation.articles": "Artikel",
    "navigation.back": "Zurück",
    "navigation.breakingnews": "Breaking News",
    "navigation.categories": "Kategorien",
    "navigation.collections": "Kollektion",
    "navigation.curatedList": "Workflow-Liste",
    "navigation.embeds": "Embedded content",
    "navigation.geneeaEntities": "Geneea-Entitäten",
    "navigation.kickwords": "Kickwords",
    "navigation.links": "Externe Links",
    "navigation.newsletters": "Newsletter",
    "navigation.placement": "Platzierung",
    "navigation.rtelements": "Komponenten",
    "navigation.shortcuts": "Tastenkürzel",
    "navigation.sitemaps": "Sitemaps",
    "navigation.slideshows": "Bildstrecken",
    "navigation.tags": "Tags",
    "navigation.teams": "Teams & Spieler",
    "navigation.tickers": "Liveticker",
    "navigation.users": "Accounts",
    "navigation.userSettings": "Mein Konto",
    "navigation.videos": "Video",
    "newsletter.relatedcontent.modal.title": "Inhalt auswählen",
    "newsletters.edit": "Newsletter bearbeiten",
    "newsletters.hasConfig.title": "Dieser Newsletter wird auf einem Artikel-Teaser  angezeigt.",
    "newsletters.list.tab.active": "Aktiv",
    "newsletters.list.tab.all": "Alle",
    "newsletters.list.tab.inactive": "Inaktiv",
    "newsletters.multipleSelected": "Falls auf einer Kategorie mehrere Newsletter angezeigt werden sollen, wird einer zufällig ausgewählt.",
    "newsletters.showCta": "Newsletter CTA auf diesem Artikel-Teaser anzeigen",
    "newsletters.showSubscriptionsFromCategories": "Newsletter-Abonnierung auf Artikeln von diesen Kategorien anzeigen",
    "newVersion": "Unity verfügt über eine neue Version {{newVersion}}. Bitte zuerst speichern und dann das <reloadLink>Browser Fenster neu laden</reloadLink> !",
    "overviewList.actions.cloneArticleContent": "Inhalt klonen",
    "overviewList.actions.copyMetadataId": "ID kopieren",
    "overviewList.actions.copyTextForAuthorisation": "Text für Autorisierung kopieren",
    "overviewList.actions.delete": "Löschen",
    "overviewList.actions.duplicate": "Duplizieren",
    "overviewList.author": "Autor:in",
    "overviewList.characters": "Zeichen",
    "overviewList.contentStatus": "Inhaltsstatus",
    "overviewList.createdAt": "Erstellt",
    "overviewList.createdBy": "Ersteller",
    "overviewList.endTime": "Abgeschlossen",
    "overviewList.image": "Teaser-Bild",
    "overviewList.itemsOnTheList": "{{totalElements}} Elemente auf der Liste",
    "overviewList.printDate": "Printdatum",
    "overviewList.publicationStatus": "Publikationsstatus",
    "overviewList.refreshedSecondsAgo": "Vor {{seconds}} Sekunde(n) aktualisiert",
    "overviewList.results": "Ergebnisse",
    "overviewList.significance": "Signifikanz",
    "overviewList.startTime": "Gestartet",
    "overviewList.status": "Status",
    "overviewList.targetTime": "Zielzeit",
    "overviewList.teaserImageA": "Bild A",
    "overviewList.teaserImageB": "Bild B",
    "overviewList.titleHeaderAndTitle": "Oberzeile und Teaser-Titel",
    "overviewList.titleHeaderAndTitleA": "Oberzeile und Teaser-Titel A",
    "overviewList.titleHeaderAndTitleB": "Oberzeile und Teaser-Titel B",
    "overviewList.updatedAt": "Geändert",
    "overviewList.users": "Verwendet",
    "page.navigation.detail": "Inhalt",
    "page.navigation.metadata": "Publikation",
    "page.navigation.pushmessages": "Push-Nachrichten",
    "page.setupForm.submitButton": "Erstellen",
    "page.setupForm.title": "Einstellungen",
    "page.title.articles": "Artikel",
    "page.title.breakingnews": "Breaking News",
    "page.title.categories": "Kategorien",
    "page.title.collections": "Kollektion",
    "page.title.curatedList": "Workflow-Liste",
    "page.title.externalContent.embeds": "Embedded content",
    "page.title.externalContent.links": "Externe Links",
    "page.title.externalContent.videos": "Video",
    "page.title.home": "Startseite",
    "page.title.kickwords": "Kickwords",
    "page.title.placement": "Platzierung",
    "page.title.rtelements": "Komponenten",
    "page.title.sitemaps": "Sitemaps",
    "page.title.slideshows": "Bildstrecken",
    "page.title.tags": "Tags",
    "page.title.teams": "Teams & Spieler",
    "page.title.tickers": "Liveticker",
    "page.title.users": "Accounts",
    "page.title.userSettings": "Mein Konto",
    "placement.columnheader.modal.config.allowAbTest": "A/B tests sind auf diese Seite freigegeben.",
    "placement.drop.modal.move.confirm": "Verschieben",
    "placement.drop.modal.replace.confirm": "Ersetzen",
    "placement.dropFromPinned.modal.description": "<paragraph>Der Inhalt <component>\"{{contentTitle}}\"</component> wird verschoben.</paragraph>",
    "placement.dropFromPinned.modal.title": "Gepinnten Inhalt verschieben?",
    "placement.dropFromPlaceholder.modal.description": "<paragraph>Der <component>{{categoryName}}</component> Platzhalter wird verschoben.</paragraph>",
    "placement.dropFromPlaceholder.modal.title": "Platzhalter verschieben?",
    "placement.dropOnPinned.modal.description": "<paragraph>Der Inhalt <component>\"{{contentTitle}}\"</component> wird ersetzt.</paragraph>",
    "placement.dropOnPinned.modal.title": "Gepinnten Inhalt ersetzen?",
    "placement.dropOnPlaceholder.modal.description": "<paragraph>Der <component>{{categoryName}}</component> Platzhalter wird ersetzt.</paragraph>",
    "placement.dropOnPlaceholder.modal.title": "Platzhalter ersetzen?",
    "placement.premiumContentBadge": "Abo",
    "placement.premiumContentBadge.tooltip": "Premium Content",
    "placement.section.copy.DEFAULT_SECTION_CANNOT_BE_COPIED.error": "Default-Sektionen können nicht kopiert werden.",
    "placement.section.copy.REMOVED_BUTTON.warning": "Der Link zu mehr Inhalten dieser Sektion führt zu einer Kategorie, die für {{tenantName}} nicht existiert. Der Link wurde entsprechend deaktiviert.",
    "placement.section.copy.REMOVED_CONTENT.warning": "Bei mindestens einem Artikel fehlt der Tenant {{tenantName}}. Die Sektion wurde ohne diesen erstellt. Um den Artikel zu platzieren, muss erst der Tenant hinzugefügt und der Artikel danach manuell per Drag&Drop platziert werden.",
    "placement.section.copy.REMOVED_PLACEHOLDERS.warning": "Der Platzhalter in der Sektion referenziert die selbe Kategorie als in der Zielseite oder die für {{tenantName}} nicht existiert. Der Platzhalter wurde wurde aus der Kopie entfernt.",
    "placement.section.copy.SECTION_CANNOT_BE_COPIED_TO_ITS_REFERENCED_PAGE.error": "Die in dieser Sektion festgelegte Kategorie ist die gleiche wie auf der Zielseite. In diesem Fall ist das Kopieren nicht möglich.",
    "placement.section.copy.SECTION_CATEGORY_IS_MISSING_IN_THE_TARGET_SITEMAP.error": "Die in dieser Sektion festgelegte Kategorie ist in der Sitemap von {{tenantName}} nicht vorhanden. Um diese Sektion zu kopieren, muss erst ein Element für diese Kategorie hinzugefügt und dann die Sektion per Drag&Drop platziert werden.",
    "placementHistory.chart.now": "Jetzt",
    "placementHistory.chart.positionInCategory": "Position in Kategorie",
    "placementHistory.chart.positionInSection": "Position in Sektion",
    "placementHistory.chart.time": "Zeit",
    "placementHistory.chart.title": "Platzierungsverlauf-Diagramm",
    "placementHistory.closeButton.title": "Schliessen",
    "placementHistory.title": "Platzierungsverlauf",
    "placementHistory.toolbar.dateRange.clear": "Leeren",
    "placementHistory.toolbar.tenant": "Mandant",
    "placementtool.column.by": "von",
    "placementtool.column.category.placeholder": "Kategorie",
    "placementtool.column.createButton": "Spalte hinzufügen",
    "placementtool.column.drop.error.addTenantFirst": "Bitte füge den Mandanten \"{{ tenantName }}\" zuerst in den Publikationsdaten des Inhalts hinzu.",
    "placementtool.column.fullDatePrefix": "am",
    "placementtool.column.lastPublished": "Default zuletzt publiziert",
    "placementtool.column.pageType.category.label": "Kategorie",
    "placementtool.column.pageType.label": "Seitentyp",
    "placementtool.column.pageType.tag.label": "Tag",
    "placementtool.column.tag.placeholder": "Tag",
    "placementtool.column.toolbar.section.create": "Sektion hinzufügen",
    "placementtool.column.toolbar.submitButton": "publizieren",
    "placementtool.columnheader.closeButton.tooltip": "Schliessen",
    "placementtool.columnheader.config.title": "Konfiguration",
    "placementtool.columnheader.modal.notPublished": "Noch nicht publiziert!",
    "placementtool.columnheader.modal.notPublished.continue": "Änderungen sind noch nicht publiziert! Trotzdem fortfahren?",
    "placementtool.columnheader.tenant": "Mandant",
    "placementtool.contentItem.deleted": "gelöscht",
    "placementtool.contentItem.notPublishedYet": "Noch nicht publiziert",
    "placementtool.contentItem.unpublished": "nicht mehr publiziert",
    "placementtool.drop.hint": "Element hier einfügen",
    "placementtool.history": "Geschichte",
    "placementtool.history.by": "von",
    "placementtool.history.modal.message": "Hiermit werden alle aktuellen Änderungen überschrieben. Dies kann NICHT rückgängig gemacht werden. Publiziert wird hierbei aber noch nicht.",
    "placementtool.history.modal.title": "Achtung!",
    "placementtool.metadatalist.articles.title": "Alle Inhalte",
    "placementtool.metadatalist.bookmarks.title": "Lesezeichen",
    "placementtool.placeholderModal.title.create": "Platzhalter erstellen",
    "placementtool.placeholderModal.title.edit": "Platzhalter editieren",
    "placementtool.section.content_block": "Rich-Text",
    "placementtool.section.external_widget": "Recommender",
    "placementtool.section.no_logic": "Leerer Container",
    "placementtool.section.ta-placement-engine": "TGD Recommender",
    "placementtool.sectionForm.adPositionsSection.title": "Werbepositionen",
    "placementtool.sectionForm.adsPositions.desktop": "Desktop Web",
    "placementtool.sectionForm.appearanceSection.title": "Aussehen",
    "placementtool.sectionForm.backgroundColor": "Hintergrundfarbe",
    "placementtool.sectionForm.backgroundColor.blue": "Blau",
    "placementtool.sectionForm.backgroundColor.brown": "Braun",
    "placementtool.sectionForm.backgroundColor.green": "Grün",
    "placementtool.sectionForm.backgroundColor.mint": "Mintgrün",
    "placementtool.sectionForm.backgroundColor.neutral": "Neutral",
    "placementtool.sectionForm.backgroundColor.none": "Kein Hintergrund",
    "placementtool.sectionForm.backgroundColor.orange": "Orange",
    "placementtool.sectionForm.backgroundColor.pink": "Rosa",
    "placementtool.sectionForm.backgroundColor.purple": "Violett",
    "placementtool.sectionForm.backgroundColor.tenantColor": "Titel-Farbe",
    "placementtool.sectionForm.buttonLink.categoryLink.label": "Kategorie",
    "placementtool.sectionForm.buttonLink.internalLink.label": "Interner Link",
    "placementtool.sectionForm.buttonLink.label": "Button-Ziel",
    "placementtool.sectionForm.buttonLink.link.label": "Externer Link",
    "placementtool.sectionForm.buttonLink.tagLink.label": "Tag",
    "placementtool.sectionForm.buttonSection.title": "Button",
    "placementtool.sectionForm.buttonTextField.label": "Button-Text",
    "placementtool.sectionForm.categories.label": "Kategorie Referenz",
    "placementtool.sectionForm.categoryToBeLinkedTo.label": "Kategorie verlinken",
    "placementtool.sectionForm.content.label": "Inhalt",
    "placementtool.sectionForm.customTypeIdentifier.label": "Kennung",
    "placementtool.sectionForm.defaultCategory.label": "Standardkategorie",
    "placementtool.sectionForm.freshPin.label": "Frische Inhalte bevorzugen",
    "placementtool.sectionForm.isButtonVisible.label": "Button anzeigen",
    "placementtool.sectionForm.isInfiniteScroll.label": "Infinite scroll",
    "placementtool.sectionForm.isSectionVisible.label": "Sektion anzeigen",
    "placementtool.sectionForm.layouts.default": "Default",
    "placementtool.sectionForm.layouts.label": "Layout",
    "placementtool.sectionForm.layouts.newfront_bundle": "Bundle",
    "placementtool.sectionForm.layouts.newfront_highlight": "Highlight",
    "placementtool.sectionForm.layouts.newfront_horizontal-scroll": "Horizontal Scroll",
    "placementtool.sectionForm.layouts.newfront_horizontal-stacked": "Horizontal Stacked",
    "placementtool.sectionForm.layouts.newfront_latest-news": "Neueste Nachrichten",
    "placementtool.sectionForm.layouts.newfront_list": "List",
    "placementtool.sectionForm.layouts.newfront_micro": "Micro",
    "placementtool.sectionForm.layouts.newfront_newsbriefing": "News-Briefing",
    "placementtool.sectionForm.layouts.newfront_opener-list": "Opener List",
    "placementtool.sectionForm.layouts.newfront_opener-overview": "Opener Overview",
    "placementtool.sectionForm.layouts.newfront_opener-top": "Opener Top",
    "placementtool.sectionForm.layouts.newfront_panorama": "Panorama",
    "placementtool.sectionForm.layouts.newfront_standard-even": "Standard Even",
    "placementtool.sectionForm.layouts.newfront_standard-uneven": "Standard Uneven",
    "placementtool.sectionForm.navigationLayout.dropdown": "Dropdown Layout",
    "placementtool.sectionForm.navigationLayout.link": "Link Layout",
    "placementtool.sectionForm.recommenderSection.title": "Empfehlungssystem",
    "placementtool.sectionForm.searchText.label": "Suchtext",
    "placementtool.sectionForm.selectableCategories.label": "Wählbare Kategorien",
    "placementtool.sectionForm.showTitle.label": "Titel anzeigen",
    "placementtool.sectionForm.subtitle.label": "Untertitel",
    "placementtool.sectionForm.tag.label": "Tag-Referenz",
    "placementtool.sectionForm.tagToBeLinkedTo.label": "Tag verlinken",
    "placementtool.sectionForm.teaserCount.label": "Anzahl Inhalte",
    "placementtool.sectionForm.url.label": "Link URL",
    "placementtool.sectionForm.weightMomentum.label": "Momentum-Gewicht",
    "placementtool.sectionForm.weightPerformance.label": "Performance-Gewichtung",
    "placementtool.sectionForm.weightRecency.label": "Aktualitäts-Gewicht",
    "placementtool.sectionForm.weightSemantic.label": "Semantisches Gewicht",
    "placementtool.sectionForm.widgetId.label": "Widget ID",
    "placementtool.sectionModal.add.title": "Sektion anlegen",
    "placementtool.sectionModal.closeButton.tooltip": "Schliessen",
    "placementtool.sectionModal.edit.title": "Sektion bearbeiten",
    "placementtool.sectionModal.form.submitButton": "Speichern",
    "placementtool.sectionModal.titleField.label": "Titel",
    "placementtool.sectionModal.type.category": "Kategorie",
    "placementtool.sectionModal.type.category.new": "Zeige immer den ersten Inhalt der Kategorie…",
    "placementtool.sectionModal.type.content_block": "Rich-Text",
    "placementtool.sectionModal.type.custom": "Custom",
    "placementtool.sectionModal.type.default": "Default",
    "placementtool.sectionModal.type.external_widget": "Recommender",
    "placementtool.sectionModal.type.label": "Typ",
    "placementtool.sectionModal.type.no_logic": "Leerer Container",
    "placementtool.sectionModal.type.ta-placement-engine": "TGD Recommender",
    "placementtool.sectionModal.type.tag": "Tag",
    "placementtool.sectionModal.type.user_category_selection": "Mehrere Kategorien",
    "placementtool.sectionpresets.add.button": "Ansicht speichern",
    "placementtool.sectionpresets.input.placeholder": "Bezeichnung",
    "placementtool.sections.collapseAll": "Alle schliessen",
    "placementtool.sections.expandAll": "Alle öffnen",
    "preview.error.metadata": "Metadaten konnten nicht gefunden werden.",
    "preview.error.notAvailable": "Vorschau ist nicht verfügbar",
    "preview.input.error.max.height": "Maximalhöhe: {{maxSize}}",
    "preview.input.error.max.width": "Maximalbreite: {{maxSize}}",
    "preview.input.error.min.height": "Mindesthöhe: {{minSize}}",
    "preview.input.error.min.width": "Mindestbreite: {{minSize}}",
    "preview.pageHeader.title": "Preview",
    "preview.pageHeader.tooltip": "Die Vorschau zeigt die aktuellen Änderungen nicht an? Es dauert einen Moment, bis die Änderungen in der Vorschau sichtbar sind. Änderungen müssen gespeichert werden, bevor die Vorschau geöffnet wird, sonst werden die Änderungen nicht angezeigt. Die Vorschau kann mit ctrl+shift+R bzw. cmd+shift+R aktualisiert werden. Wenn der Artikel für mehr als einen Titel erstellt wurde, kann im Dropdown der Titel geändert werden, dies hilft auch bei der Aktualisierung der Vorschau.",
    "publicationStatus": "Publikationsstatus",
    "publicationStatus.internalOnly": "Nur interne KI",
    "publicationStatus.internalOnly.tooltip": "Nicht öffentlich, nicht in Google, aber zugänglich für interne KI-Systeme.",
    "publicationStatus.notPublished": "Nicht publiziert",
    "publicationStatus.notPublished.tooltip": "Nicht öffentlich, nicht indexiert, keine KI-Nutzung.",
    "publicationStatus.published": "Publiziert",
    "publicationStatus.published.tooltip": "Sichtbar für alle (User, Google, interne KI).",
    "publicationStatus.unlisted": "Nicht bei Google",
    "publicationStatus.unlisted.tooltip": "Nicht über Google auffindbar, aber zugänglich via Direktlink, interne KI erlaubt.",
    "publicationStatus.unpublished": "Gelöscht",
    "publicationStatus.unpublished.tooltip": "Keine Sichtbarkeit, keine Nutzung durch KI.",
    "pushHistory.streamboat.noStatus": "Kein Status für Streamboat verfügbar.",
    "pushStatus.description.externalError": "<p>Status konnte <strong>vorübergehend nicht überprüft</strong> werden.</p>",
    "pushStatus.description.failed": "<p>Senden der Nachricht <strong>fehlgeschlagen</strong>. Keine Nachricht wurde an Abonnenten versandt.</p>",
    "pushStatus.description.finished": "<p>Senden der Nachricht <strong>abgeschlossen</strong>.</p> <p>Der Versand dauerte {{duration}} minuten.</p>",
    "pushStatus.description.sending": "<p><strong>Senden</strong> der Nachricht an Abonnenten.</p> <p>Sendet seit {{duration}} minuten.</p>",
    "pushStatus.description.unknown": "Ein unbekannter Fehler ist aufgetreten",
    "pushStatus.externalError": "Externer Fehler",
    "pushStatus.failed": "Gescheitert",
    "pushStatus.finished": "Fertig",
    "pushStatus.sending": "Senden",
    "pushStatus.unknown": "Unbekannt",
    "releaseNotes.btnCreate": "Create new",
    "releaseNotes.form.labelEdit": "Edit note",
    "releaseNotes.form.labelNew": "Add note",
    "releaseNotes.noContent": "Kein Inhalt",
    "releaseNotes.title": "Release note",
    "releaseNotes.visible": "Visible",
    "revision.currentTag": "Aktuelle Revision",
    "revision.modal.confirmationMessage": "Bist du sicher, dass du die Revision wiederherstellen möchtest?",
    "revision.modal.confirmButton": "Wiederherstellen",
    "revision.modal.newRevisionMessage": "Darauf besierend wird eine neue Revision erstellt.",
    "revision.modal.title": "Revision wiederherstellen",
    "revision.modal.unpublishMessage": "Der Artikel wird unveröffentlicht",
    "revision.restoreTag": "Wird nach der Wiederherstellung zu einer neuen Revision",
    "richtext.error.critical": "Beim speichern des Feldes ist ein Fehler aufgetreten.",
    "richtext.warning.restore": "Es ist ein Problem mit dem Editor aufgetreten. Der letztbekannte Content ist wiederhergestellt worden.",
    "router.modal.content": "Änderungen sind noch nicht gespeichert. <br /> Soll Unity wirklich diese Seite schliessen und ohne zu speichern fortfahren?",
    "router.modal.leave": "Ja, Seite ohne speichern verlassen",
    "router.modal.stay": "Nein, zurück",
    "router.modal.title": "Achtung, Unity meldet:",
    "rtElement.form.infobox.name": "Name",
    "rtElement.form.infobox.tenants": "Mandanten",
    "rtElement.form.title.create": "Komponente erstellen",
    "rtElement.form.title.edit": "Bearbeiten",
    "rtElement.name": "Name",
    "rtElement.tenants": "Mandanten",
    "rtElements.list.addButton": "Komponente erstellen",
    "rtElements.list.title": "Komponenten",
    "rtElements.type.snippet": "Baustein",
    "scoreboard.resultAdditive.ot": "n.V.",
    "scoreboard.resultAdditive.so": "n.P.",
    "scoreboardForm.resultAdditive.label": "Schlussresultat Zusatz",
    "scoreboardForm.resultAdditive.ot": "Nach Verlängerung (n.V.)",
    "scoreboardForm.resultAdditive.so": "Nach Penalty (n.P.)",
    "search.authors.label": "Nutzer/Agentur",
    "search.authors.nonefound": "Kein Nutzer/Agenturen gefunden",
    "search.category.label": "Kategorien",
    "search.contentStatus.label": "Inhaltsstatus",
    "search.contentType.label": "Inhalte",
    "search.filterButton.less": "Weniger Filter",
    "search.filterButton.more": "Mehr Filter",
    "search.filterButton.reset": "Filter zurücksetzen",
    "search.leagues.iceHockey.label": "Liga",
    "search.leagues.soccer.label": "Liga",
    "search.leagues.tennis.label": "Modus",
    "search.main.label": "Suchen",
    "search.minCharacters": "Bitte mindestens 2 Zeichen eingeben",
    "search.publicationStatus.label": "Publikationsstatus",
    "search.publishedAfter.label": "Publiziert von",
    "search.publishedBefore.label": "Publiziert bis",
    "search.tab.keyword": "Stichwortsuche",
    "search.tab.semantic": "Semantische Suche",
    "search.tags.label": "Tags",
    "search.tenants.label": "Mandanten",
    "semanticSearch.loadMore": "Mehr laden",
    "semanticSearch.slider.almostSame": "fast gleich",
    "semanticSearch.slider.similar": "ähnlich",
    "semanticSearch.slider.slightlySimilar": "etwas ähnlich",
    "semanticSearch.slider.verySimilar": "sehr ähnlich",
    "semanticSearch.tooltip": "Die semantische Suche unterscheidet sich deutlich von der Stichwortsuche. Sie prüft nicht die Übereinstimmung von Buchstaben und Wörtern, sondern kann auch Synonyme und verwandte Konzepte finden. Bei der Suche nach einem Wort wie «Obst» werden auch Texte mit verwandten Begriffen wie «Apfel» oder «Birne» gefunden. Sie ermöglicht es, den Grad der Ähnlichkeit festzulegen - also wie stark die gefundenen Texte thematisch zur Suchanfrage passen müssen. Gesucht werden kann auch mit Kontext oder Fragen. <br/> <strong> Beispiel </strong>: Die Suche nach Artikeln über 'Verkehrsprobleme in der Gemeinde'. Die semantische Suche findet nicht nur Texte mit genau diesen Wörtern, sondern auch Artikel über 'Stau auf der Kantonsstrasse', 'Parkplatznot beim Bahnhof', 'Diskussion um Tempo 30-Zone' oder 'ÖV-Anbindung problematisch' - alles relevante Inhalte zum gleichen Thema, auch wenn andere Begriffe verwendet wurden.",
    "shortcuts.action.bold": "Fett",
    "shortcuts.action.cancel": "Abbrechen",
    "shortcuts.action.cycleRegion": "Durch die Seitenbereiche navigieren",
    "shortcuts.action.focusContentStatus": "Inhaltsstatus fokussieren",
    "shortcuts.action.focusPublicationStatus": "Publikationsstatus fokussieren",
    "shortcuts.action.insertMenuSwitchColumn": "Element-Menü: Spalte wechseln",
    "shortcuts.action.insertMenuSwitchTab": "Element-Menü: Tab wechseln",
    "shortcuts.action.italic": "Kursiv",
    "shortcuts.action.link": "Link einfügen oder bearbeiten",
    "shortcuts.action.metadataHistory": "Metadaten-Verlauf öffnen",
    "shortcuts.action.moveElementDown": "Element nach unten verschieben",
    "shortcuts.action.moveElementUp": "Element nach oben verschieben",
    "shortcuts.action.openComments": "Kommentare öffnen",
    "shortcuts.action.openInsertMenu": "Element-Menü öffnen",
    "shortcuts.action.openMetadataFromOverview": "Metadaten aus der Übersicht öffnen",
    "shortcuts.action.openSpellChecker": "Rechtschreibprüfung öffnen",
    "shortcuts.action.orderedList": "Nummerierte Liste",
    "shortcuts.action.placementHistory": "Platzierungs-Verlauf öffnen",
    "shortcuts.action.preview": "Vorschau öffnen",
    "shortcuts.action.rephrase": "Absatz umformulieren",
    "shortcuts.action.save": "Speichern",
    "shortcuts.action.showShortcuts": "Tastenkürzel anzeigen",
    "shortcuts.action.subscript": "Tiefgestellt",
    "shortcuts.action.superscript": "Hochgestellt",
    "shortcuts.action.switchTabContent": "Zum Tab Inhalt wechseln",
    "shortcuts.action.switchTabPublication": "Zum Tab Publikation wechseln",
    "shortcuts.action.switchTabPush": "Zum Tab Push wechseln",
    "shortcuts.action.underline": "Unterstrichen",
    "shortcuts.action.unorderedList": "Aufzählung",
    "shortcuts.category.editor": "Editor",
    "shortcuts.category.navigation": "Navigation",
    "shortcuts.category.page": "Seitenaktionen",
    "shortcuts.dialog.closeButton.title": "Schliessen",
    "shortcuts.dialog.title": "Tastenkürzel",
    "showmore.title.closed": "Mehr anzeigen",
    "showmore.title.open": "Weniger anzeigen",
    "sitemap.edit.defaultTitle": "Element hinzufügen",
    "sitemap.edit.title": "Element bearbeiten",
    "sitemap.fixedmenubar.restore": "Wiederherstellen",
    "sitemap.fixedmenubar.save": "Änderungen speichern",
    "sitemap.form.allowRobots": "In den Suchmaschinen anzeigen",
    "sitemap.form.availableFor": "Verfügbar für",
    "sitemap.form.availableFor.app": "App",
    "sitemap.form.availableFor.desktop": "Desktop",
    "sitemap.form.categoryReference": "Referenz auf Kategorie",
    "sitemap.form.categoryUrlPath": "URL Slug",
    "sitemap.form.clientPageIdentifier": "Identifier",
    "sitemap.form.clientPagePath": "Path",
    "sitemap.form.contentLink": "Externe URL",
    "sitemap.form.contentReference": "Referenz auf Inhalt",
    "sitemap.form.contentUrlSlug": "URL Slug",
    "sitemap.form.contentUrlSlug.description": "Dies wird den URL Slug des Inhalts überschreiben.",
    "sitemap.form.icon": "Icon",
    "sitemap.form.indexing": "Indexieren",
    "sitemap.form.metaDescription": "Meta Description",
    "sitemap.form.metaTitle": "Meta Title",
    "sitemap.form.modal.deleteMessage": "Wenn dieses Sitemap Element gelöscht wird und Unterpunkte beinhaltet, werden diese auch gelöscht. Dies gilt auch für die Menüs.",
    "sitemap.form.name": "Anzeigename",
    "sitemap.form.newWindow": "In neuem Fenster öffnen",
    "sitemap.form.nodeType": "Node Typ",
    "sitemap.form.notFoundContent": "Kategorie nicht vorhanden",
    "sitemap.form.pageStyle.caption": "Stil der Seite",
    "sitemap.form.pageStyle.dasMagazin": "Das Magazin",
    "sitemap.form.pageStyle.default": "Default",
    "sitemap.form.pageStyle.video": "Video",
    "sitemap.form.pageStyle.zueriTipp": "Züritipp",
    "sitemap.form.subtitle": "Untertitel",
    "sitemap.form.tagReference": "Referenz auf Tag",
    "sitemap.form.tagUrlSlug": "URL-Slug",
    "sitemap.form.tagUrlSlug.description": "Bestandteil der URL, der den Inhalt beschreibt. Erlaubte Zeichen sind a-z, 0-9 und -. Ihm wird immer der Bezeichner \"tags/\" vorangestellt. Beispiel: …/tags/ihr-tag-name",
    "sitemap.form.type.category": "Kategorie",
    "sitemap.form.type.clientPage": "Static page",
    "sitemap.form.type.content": "Inhalt",
    "sitemap.form.type.external": "Externer Link",
    "sitemap.form.type.group": "Gruppe",
    "sitemap.form.type.tag": "Tag",
    "sitemap.list.addButton": "Hinzufügen",
    "sitemap.list.placeholder.name": "(Neues Element)",
    "sitemap.menu.cancelButton": "Wiederherstellen",
    "sitemap.menu.highlighted": "Hervorgehoben",
    "sitemap.menu.labels.footer": "Footer",
    "sitemap.menu.labels.menu": "Menü",
    "sitemap.menu.labels.menuFooter": "Menü Footer",
    "sitemap.menu.labels.topNavigation": "Top Navigation",
    "sitemap.menu.labels.userPanel": "User Panel",
    "sitemap.menu.modal.deleteButton": "Element entfernen",
    "sitemap.menu.modal.submitButton": "Übernehmen",
    "sitemap.menu.modal.title": "Menü Element editieren",
    "sitemap.menu.placeholder": "Menü auswählen",
    "sitemap.menu.submitButton": "Änderungen speichern",
    "sitemap.menu.title": "Menü",
    "sitemap.tenantSelector.placeholder": "Mandant",
    "slidelist.validation.message": "Es existieren Slides mit fehlenden Informationen",
    "slideshow.bulkSlideForm.title": "Alle Slides bearbeiten",
    "slideshow.detail.editButton": "Bildstrecke Details bearbeiten",
    "slideshow.detail.title": "Bildstrecke Details",
    "slideshow.editorPlugin.preview.noSlideLink": "Bildstrecke bearbeiten",
    "slideshow.editorPlugin.preview.noSlideMessage": "Keine Bilder in der Bildstrecke.",
    "slideshow.form.lead": "Lead",
    "slideshow.form.title": "Titel",
    "slideshow.form.titleHeader": "Oberzeile",
    "slideshow.list.createButton": "Bildstrecke erstellen",
    "slideshow.navigation.next": "Nächste",
    "slideshow.navigation.previous": "Vorige",
    "slideshow.router.modal.content": "Es wurden noch nicht für alle Slides Bildbeschreibungen generiert. Wenn du jetzt gehst, bleiben diese leer. <br/> Soll Unity wirklich diese Seite schliessen und ohne zu speichern fortfahren?",
    "slideshow.setup.pageTitle": "Neue Bildstrecke",
    "slideshow.slideform.invalidTooltip": "Um den Teaser anzupassen, müssen alle Slides fehlerfrei sein.",
    "slideshow.slideform.setImage": "Setze Bild als Teaser Bild",
    "slideshow.slideform.title": "Slide bearbeiten",
    "slideshow.slideform.visible": "Sichtbar",
    "slideshow.slidelist.addButton": "Slide erstellen",
    "slideshow.slidelist.editAll": "Alle bearbeiten",
    "slideshow.slidelist.restore": "Wiederherstellen",
    "slideshow.slidelist.save": "Reihenfolge speichern",
    "slideshow.slidelist.saveOrder": "Speichere zuerst die Reihenfolge",
    "slideshow.slidelist.title": "Slides {{quantity}}",
    "spellchecker.error.overload.message": "Die Rechtschreibprüfung ist derzeit überlastet. Bitte später erneut versuchen.",
    "spellchecker.error.timeout.message": "Die Rechtschreibprüfung dauerte länger als erwartet und ist fehlgeschlagen. Bitte nochmals versuchen.",
    "statusSelect.disabled.tooltip": "Um den Status zu wechseln, bitte erst speichern",
    "tag.description": "Beschreibung",
    "tag.edit.title": "Edit Tag",
    "tag.form.active": "Aktiv",
    "tag.form.allowRobots": "In den Suchmaschinen anzeigen",
    "tag.form.asyncvalidate.reject": "Der Name ist bereits vergeben",
    "tag.form.description": "Beschreibung",
    "tag.form.geneeaEntity.hint": "Mit dieser Entität markierte Artikel erscheinen automatisch auf der Seite dieses Tags. Wenn du das nicht möchtest, entferne die Entität oben und speichere die Änderungen.",
    "tag.form.geneeaEntity.label": "Zugewiesene Entität",
    "tag.form.image": "Bild",
    "tag.form.name": "Name",
    "tag.form.title": "Titel",
    "tag.list.addButton": "Tag erstellen",
    "tag.list.tab.active": "Aktiv",
    "tag.list.tab.all": "Alle",
    "tag.name": "Name",
    "tag.setup.title": "Tag erstellen",
    "tag.title": "Titel",
    "team.edit.title": "Team bearbeiten",
    "team.form.image": "Bild",
    "team.form.image.edit": "Bild bearbeiten",
    "team.form.leagues": "Ligen",
    "team.form.leagues.placeholder": "Ligen auswählen...",
    "team.form.name": "Name",
    "team.form.noResults": "Keine Suchergebnisse gefunden",
    "team.header.select.iceHockeyTeams": "Eishockey Teams",
    "team.header.select.leaguesAndTournaments": "Ligen und Turniere",
    "team.header.select.soccerTeams": "Fussball Teams",
    "team.header.select.tennisPlayers": "Tennisspieler",
    "team.route.iceHockeyTeams.create.label": "Team hinzufügen",
    "team.route.leaguesAndTournaments.create.label": "Liga oder Turnier",
    "team.route.soccerTeams.create.label": "Team hinzufügen",
    "team.route.tennisPlayers.create.label": "Spieler hinzufügen",
    "team.setup.title": "Team erstellen",
    "team.type.select": "Teams, Spieler, Ligen und Turniere...",
    "teaser.form.submitButton": "Ok",
    "tenantchooser.editButton": "Mandanten bearbeiten",
    "tenantchooser.mainTenant": "Haupt-Mandant",
    "tenantchooser.mainTenant.placeholder": "Haupt-Mandant auswählen",
    "tenantchooser.modal.title": "Ausgewählte Mandanten",
    "tenantgroup.checkbox.bern": "Bern",
    "tenantgroup.checkbox.régionaux": "Regionale",
    "tenantgroup.checkbox.tamediaNews": "Tamedia news",
    "tenantgroup.checkbox.zürich": "Zürich",
    "tenants.selection.submitButton": "Übernehmen",
    "tenantspecific.copy.button": "Anwenden",
    "tenantSpecific.copy.label": "Werte kopieren zu:",
    "tenantSpecific.copy.placeholder": "Mandanten auswählen",
    "tenantspecific.error": "Fehlerhafte Eingaben gefunden",
    "tenantspecific.variantButton": "Varianten",
    "tennis.edit.title": "Spieler / Doppel bearbeiten",
    "tennis.form.name": "Name des Spielers / Doppels",
    "tennis.form.radio.title.mode": "Modus",
    "tennis.setup.title": "Spieler / Doppel erstellen",
    "ticker.content.editButton": "Bearbeiten",
    "ticker.content.editPost": "Eintrag bearbeiten",
    "ticker.content.newPost": "Neuer Eintrag",
    "ticker.event.athletics": "Athletics",
    "ticker.event.basketball": "Basketball",
    "ticker.event.beachVolleyball": "Beach-Volleyball",
    "ticker.event.card": "Karte",
    "ticker.event.crossCountrySkiing": "Cross-Country Skiing",
    "ticker.event.curling": "Curling",
    "ticker.event.cycling": "Cycling",
    "ticker.event.equestrianism": "Equestrianism",
    "ticker.event.fencing": "Fencing",
    "ticker.event.figureSkating": "Figure Skating",
    "ticker.event.formula1": "Formula 1",
    "ticker.event.freeText": "Other",
    "ticker.event.game": "Spiel",
    "ticker.event.gameEnd": "Spielende",
    "ticker.event.gameMinute": "Spielminute",
    "ticker.event.gameStart": "Spielstart",
    "ticker.event.goal": "Tor",
    "ticker.event.golf": "Golf",
    "ticker.event.halftimeEnd": "Halbzeitende",
    "ticker.event.halftimeStart": "Halbzeitbeginn",
    "ticker.event.horseRiding": "Horse riding",
    "ticker.event.iceHockey": "Ice Hockey",
    "ticker.event.info": "Info",
    "ticker.event.match": "Match",
    "ticker.event.miss": "Fehlschuss",
    "ticker.event.overtimeEnd": "Ende Verlängerung",
    "ticker.event.overtimeStart": "Beginn Verlängerung",
    "ticker.event.penalty": "Strafe",
    "ticker.event.periodEnd": "Drittelende",
    "ticker.event.periodStart": "Drittelbeginn",
    "ticker.event.point": "Punkt",
    "ticker.event.set": "Satz",
    "ticker.event.shootOut": "Penaltyschiessen",
    "ticker.event.shootOutEnd": "Ende Penaltyschiessen",
    "ticker.event.shootOutStart": "Beginn Penaltyschiessen",
    "ticker.event.skiing": "Skiing",
    "ticker.event.snowboarding": "Snowboarding",
    "ticker.event.soccer": "Soccer",
    "ticker.event.substitution": "Auswechslung",
    "ticker.event.swimming": "Swimming",
    "ticker.event.team1": "Team 1",
    "ticker.event.team2": "Team 2",
    "ticker.event.tennis": "Tennis",
    "ticker.event.tiebreak": "Tiebreak",
    "ticker.event.timeEvent": "Zeitereignis",
    "ticker.event.timeout": "Timeout",
    "ticker.event.volleyball": "Volleyball",
    "ticker.eventform.compact.eventType.placeholder": "Select a sport...",
    "ticker.eventform.date": "Datum",
    "ticker.eventform.dateTime": "Zeit",
    "ticker.eventform.displayTime": "Zeit anzeigen",
    "ticker.eventform.error": "Stelle den Eintrag auf nicht sichtbar oder gib eine Nachricht ein",
    "ticker.eventform.eventType.label": "Typ",
    "ticker.eventform.keyEvent": "Schlüsselereignis",
    "ticker.eventform.keyEvent.title.required": "Ist das \"Schlüsselereignis\" angekreuzt, darf der Eintragstitel nicht leer sein.",
    "ticker.eventform.message": "Nachricht",
    "ticker.eventform.title": "Titel",
    "ticker.eventform.visible": "Sichtbar",
    "ticker.eventlist.teaser": "Teaser",
    "ticker.eventlist.teaserform.applyteaser": "Änderungen für Teaser übernehmen",
    "ticker.eventlist.teaserform.intro": "Intro",
    "ticker.eventlist.teaserform.lead": "Lead",
    "ticker.eventlist.teaserform.title": "Titel",
    "ticker.eventlist.teaserform.titleHeader": "Oberzeile",
    "ticker.list.createButton": "Ticker erstellen",
    "ticker.list.pageTitle": "Livetickers",
    "ticker.setup.league.league": "League",
    "ticker.setup.league.mode": "Mode",
    "ticker.setup.noTeamFound": "Keine Mannschaft gefunden",
    "ticker.setup.pageTitle": "Neuer Liveticker",
    "ticker.setup.scoreboardEnabled": "Standardanzeigetafel anzeigen",
    "ticker.setup.teamSelector.player": "Spieler",
    "ticker.setup.teamSelector.team": "Mannschaft",
    "ticker.setup.tickerType": "Liveticker Typ",
    "ticker.soccer.card.red": "Rot",
    "ticker.soccer.card.yellow": "Gelb",
    "ticker.soccer.redCard": "Rote Karte",
    "ticker.soccer.yellowCard": "Gelbe Karte",
    "ticker.tennis.break": "Break",
    "ticker.tennis.breakball": "Breakball",
    "ticker.tennis.matchball": "Matchball",
    "ticker.tennis.mini-break": "Mini-Break",
    "ticker.tennis.scoreboard.match.finished": "Match ist vorbei",
    "ticker.tennis.scoreboard.serveFirst": "Aufschlag bei Spielbeginn",
    "ticker.tennis.set": "Satz",
    "ticker.tennis.setball": "Satzball",
    "ticker.type.iceHockey": "Eishockey",
    "ticker.type.soccer": "Fussball",
    "ticker.type.sportsCompact": "Sport Kompakt",
    "ticker.type.standard": "Standard",
    "ticker.type.tennis": "Tennis",
    "toolbar.articleBuddy.approve": "Übernehmen",
    "toolbar.articleBuddy.backButton.title": "Neue Prüfung",
    "toolbar.articleBuddy.category.balancedReporting.description": "Erkennt selektive Auslassungen oder Verzerrungen, die das Gesamtbild verzerren. Prüft, ob relevante Fakten fehlen oder der Kontext manipuliert wurde.",
    "toolbar.articleBuddy.category.balancedReporting.label": "Ausgewogene Berichterstattung",
    "toolbar.articleBuddy.category.chartPotential.description": "Kennzeichnet Textstellen, die sich mit einer Datawrapper-Grafik oder -Karte veranschaulichen lassen. Hierzu analysiert das Tool den Artikel auf datentaugliche Inhalte. Relevante Werte bereitet es so auf, dass du sie direkt in den Datawrapper Helper laden kannst. Fehlende Daten ergänzt es aus verlässlichen öffentlichen Quellen mit Beleg.",
    "toolbar.articleBuddy.category.chartPotential.label": "Grafikpotenzial",
    "toolbar.articleBuddy.category.clarity.description": "Markiert unerklärten Fachjargon, Abkürzungen oder fehlenden Kontext. Stellt Zugänglichkeit für ein breites Publikum sicher.",
    "toolbar.articleBuddy.category.clarity.label": "Klarheit",
    "toolbar.articleBuddy.category.conflictingSources.description": "Aussagen, denen verfügbare Quellen widersprechen. Prüfe, ob die Aussage wirklich stimmt, und formuliere sie bei Bedarf um.",
    "toolbar.articleBuddy.category.conflictingSources.label": "Widersprüchliche Quellen",
    "toolbar.articleBuddy.category.contextAndAccuracy.description": "Prüft, ob Behauptungen durch Quellen gestützt sind und ausreichend Kontext für das Verständnis liefern. Prüft auf fehlende Hintergrundinformationen oder Quellen und irreführende Darstellungen.",
    "toolbar.articleBuddy.category.contextAndAccuracy.label": "Kontext & Genauigkeit",
    "toolbar.articleBuddy.category.erase.description": "Markiert Passagen, die vollständig gestrichen werden können, ohne dass der Kern der Aussage verloren geht.",
    "toolbar.articleBuddy.category.erase.label": "Weglassen",
    "toolbar.articleBuddy.category.fairness.description": "Prüft, ob Betroffene das Recht auf Gegendarstellung hatten und die Unschuldsvermutung gewahrt wird. Kritik muss sachlich formuliert sein, ohne persönliche Angriffe oder Verleumdung.",
    "toolbar.articleBuddy.category.fairness.label": "Fairness",
    "toolbar.articleBuddy.category.genderInclusiveLanguage.description": "Prüft auf generisches Maskulinum. Empfiehlt neutrale Alternativen, respektiert aber namentlich genannte Personen.",
    "toolbar.articleBuddy.category.genderInclusiveLanguage.label": "Gendergerechte Sprache",
    "toolbar.articleBuddy.category.helvetisms.description": "Stellt die konsequente Verwendung von Schweizer Standarddeutsch sicher. Ersetzt Teutonismen durch korrekte Helvetismen.",
    "toolbar.articleBuddy.category.helvetisms.label": "Schweizer Deutsch",
    "toolbar.articleBuddy.category.independence.description": "Bewertet, ob die Berichterstattung unabhängig von PR-Einflüssen ist. Prüft auf unkritische Übernahme von Pressemitteilungen, Werbesprache oder einseitige Darstellung von Produkten ohne kritischen Kontext.",
    "toolbar.articleBuddy.category.independence.label": "Unabhängigkeit",
    "toolbar.articleBuddy.category.languageStyle.description": "Prüft auf Nominalisierungen, Passivkonstruktionen, Füllwörter, Klischees und Redundanzen. Bevorzugt aktive, prägnante Formulierungen mit starken Verben.",
    "toolbar.articleBuddy.category.languageStyle.label": "Sprache & Stil",
    "toolbar.articleBuddy.category.missingSources.description": "Aussagen, für die keine stützende Quelle gefunden wurde. Prüfe, ob die Aussage wirklich stimmt, und formuliere sie bei Bedarf um.",
    "toolbar.articleBuddy.category.missingSources.label": "Fehlende Quellen",
    "toolbar.articleBuddy.category.misspelledNames.description": "Kennzeichnet Personennamen, die falsch geschrieben scheinen, und schlägt die korrekte Schreibweise vor. Hierzu gleicht das Tool jeden Namen per Websuche mit zuverlässigen Quellen ab (z. B. Behördenseiten oder Linkedin) und berücksichtigt dabei den Kontext aus dem Artikel.",
    "toolbar.articleBuddy.category.misspelledNames.label": "Falsch geschriebene Namen",
    "toolbar.articleBuddy.category.nonDiscrimination.description": "Prüft, ob Nationalität, ethnische Zugehörigkeit, Religion oder sexuelle Orientierung nur erwähnt werden, wenn sie für die Geschichte relevant sind. Verallgemeinerungen und Stereotype sollten vermieden werden.",
    "toolbar.articleBuddy.category.nonDiscrimination.label": "Nicht-Diskriminierung",
    "toolbar.articleBuddy.category.opinionVsFact.description": "Prüft, ob Meinungen klar als solche gekennzeichnet sind und nicht als Fakten dargestellt werden.",
    "toolbar.articleBuddy.category.opinionVsFact.label": "Meinung vs. Tatsache",
    "toolbar.articleBuddy.category.paraphrase.description": "Schlägt prägnantere Formulierungen vor, die die Aussage beibehalten und die Zeichenzahl reduzieren.",
    "toolbar.articleBuddy.category.paraphrase.label": "Umformulieren",
    "toolbar.articleBuddy.category.pluralism.description": "Bewertet, ob unterschiedliche Perspektiven vertreten sind, besonders bei kontroversen Themen. Prüft auf einseitige Berichterstattung oder mangelnde Vielfalt der Stimmen.",
    "toolbar.articleBuddy.category.pluralism.label": "Pluralismus",
    "toolbar.articleBuddy.category.privacy.description": "Bewertet den Umgang mit sensiblen Informationen und privaten Details. Prüft, ob die Menschenwürde gewahrt und die Privatsphäre respektiert wird.",
    "toolbar.articleBuddy.category.privacy.label": "Privatsphäre",
    "toolbar.articleBuddy.category.punctuation.description": "Prüft den korrekten Einsatz von Doppelpunkten, Gedankenstrichen und anderen Satzzeichen. Markiert Übergebrauch oder Fehlanwendung.",
    "toolbar.articleBuddy.category.punctuation.label": "Interpunktion",
    "toolbar.articleBuddy.category.quotations.description": "Bewertet, ob Zitate Mehrwert bieten (Meinung, Emotion, Originalität). Markiert leere oder redundante Zitate, die paraphrasiert oder gestrichen werden sollten.",
    "toolbar.articleBuddy.category.quotations.label": "Zitate",
    "toolbar.articleBuddy.category.sentenceStructure.description": "Identifiziert überlange oder verschachtelte Sätze. Empfiehlt Aufteilung in klare, lesbare Einheiten.",
    "toolbar.articleBuddy.category.sentenceStructure.label": "Satzbau",
    "toolbar.articleBuddy.category.sourceTransparency.description": "Prüft, ob Quellen transparent gemacht werden und Interessenkonflikte offengelegt werden. Anonymität muss redaktionell begründet sein.",
    "toolbar.articleBuddy.category.sourceTransparency.label": "Quellentransparenz",
    "toolbar.articleBuddy.category.structureNarrativeArc.description": "Bewertet Einstieg, logischen Aufbau, Übergänge und Schluss. Markiert fehlenden roten Faden oder schwache Anfänge/Enden.",
    "toolbar.articleBuddy.category.structureNarrativeArc.label": "Struktur & Dramaturgie",
    "toolbar.articleBuddy.category.supportingSources.description": "Aussagen, die von verfügbaren Quellen bestätigt werden. Kein Handlungsbedarf.",
    "toolbar.articleBuddy.category.supportingSources.label": "Stützende Quellen",
    "toolbar.articleBuddy.category.toneLanguageRegister.description": "Prüft auf unangemessene Umgangssprache, Behördendeutsch oder parteiische Formulierungen. Stellt einen neutralen, professionellen Ton sicher.",
    "toolbar.articleBuddy.category.toneLanguageRegister.label": "Register",
    "toolbar.articleBuddy.categoryTeaser": "Die Prüfung berücksichtigt die folgenden Kriterien. Es werden nur jene Kriterien angezeigt, die einen weiteren Prüfbedarf anzeigen.",
    "toolbar.articleBuddy.checklist": "Checkliste",
    "toolbar.articleBuddy.dismiss": "Ignorieren",
    "toolbar.articleBuddy.error": "Fehler beim Laden der Ergebnisse, bitte versuche es später erneut.",
    "toolbar.articleBuddy.feedback": "Hast du Feedback zum Article Buddy? Schreib deine Anregungen auf Slack: <link />",
    "toolbar.articleBuddy.intro": "Wähle die gewünschten Checks aus und starte die Analyse. Je nach Länge des Textes kann sie bis zu vier Minuten dauern.",
    "toolbar.articleBuddy.modal.confirmationMessage": "Die aktuelle Analyse des Article Buddys wird verworfen, <br /> gemachte Textanpassungen bleiben aber bestehen. <br /> Du kannst danach eine neue Analyse starten.",
    "toolbar.articleBuddy.modal.confirmationTitle": "Analyse beenden?",
    "toolbar.articleBuddy.noResults": "Keine Vorschläge.",
    "toolbar.articleBuddy.reviewCriteriaModal.closeButton.title": "Schliessen",
    "toolbar.articleBuddy.reviewCriteriaModal.title": "Prüfkriterien",
    "toolbar.articleBuddy.submitButton": "Artikel prüfen",
    "toolbar.articleBuddy.submitButton.tooltip": "Nicht gespeicherte Änderungen oder leerer Inhalt vorhanden. Bitte den Artikel vor der Überprüfung speichern.",
    "toolbar.articleBuddy.summary": "Zusammenfassung",
    "toolbar.articleBuddy.title": "Article Buddy",
    "toolbar.articleBuddy.types.factCheck.description": "Aussagen im Artikel mit verfügbaren Quellen abgleichen.",
    "toolbar.articleBuddy.types.factCheck.label": "Faktencheck",
    "toolbar.articleBuddy.types.graphic.description": "Textabschnitte identifizieren, die sich mit einer Grafik oder Karte veranschaulichen lassen.",
    "toolbar.articleBuddy.types.graphic.label": "Grafik-Check",
    "toolbar.articleBuddy.types.nameChecker.description": "Personennamen im Artikel via Websuche auf korrekte Schreibweise prüfen.",
    "toolbar.articleBuddy.types.nameChecker.label": "Namensprüfung",
    "toolbar.articleBuddy.types.shortening.description": "Intelligente Reduktion der Zeichenanzahl des Artikels gemäss Ziellänge.",
    "toolbar.articleBuddy.types.shortening.label": "Kürzungsvorschläge",
    "toolbar.articleBuddy.types.shortening.tooltip": "Kürzungsvorschläge benötigen eine festgelegte Textlänge. Ist das Feld «Vereinbarte Textlänge» im Tab «Publikation» leer oder auf «Special Length» gesetzt, sind keine Vorschläge möglich.",
    "toolbar.articleBuddy.types.standards.description": "Artikel auf redaktionelle Standards und Richtlinien prüfen.",
    "toolbar.articleBuddy.types.standards.label": "Standards",
    "toolbar.articleBuddy.types.style.description": "Artikel auf Sprache, Lesbarkeit, Struktur und Tonalität prüfen.",
    "toolbar.articleBuddy.types.style.label": "Stil",
    "toolbar.articleBuddy.verify": "Als geprüft markieren",
    "toolbar.attachments.copyImageUrl": "Bild-URL kopieren",
    "toolbar.attachments.delete.modal.message": "Soll diese Datei wirklich aus Anhängen gelöscht werden?",
    "toolbar.attachments.delete.modal.title": "Aus Anhängen löschen",
    "toolbar.attachments.deleteImage": "Bild löschen",
    "toolbar.attachments.mode.cards": "Als Karten anzeigen",
    "toolbar.attachments.mode.list": "Als Liste anzeigen",
    "toolbar.attachments.status.unused": "Online nicht verwendet",
    "toolbar.attachments.status.used": "Online verwendet",
    "toolbar.attachments.title": "Anhänge",
    "toolbar.attachments.zoomImage": "Bild vergrößern",
    "toolbar.comments.commentsInText": "... Kommentare in diesem Text",
    "toolbar.comments.description1": "Kommentare können erfasst werden, indem eine Textpassage markiert und das danach folgende Textfeld gespeichert wird.",
    "toolbar.comments.description2": "Die Kommentare können mit der Tastenkombination <kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>K</kbd> oder durch Öffnen und Schliessen des Fensters aktiviert und deaktiviert werden.",
    "toolbar.comments.title": "Kommentare",
    "toolbar.liquidContent.addFormat": "Format hinzufügen",
    "toolbar.liquidContent.articleFormat": "Artikelformat",
    "toolbar.liquidContent.articleFormats": "Artikelformate",
    "toolbar.liquidContent.create": "Liquid-Varianten erstellen",
    "toolbar.liquidContent.create.button": "Erstellen",
    "toolbar.liquidContent.create.description": "Bitte wähle unten die Formate und Mandanten aus. Sobald du den grünen Button klickst, werden die weiteren Artikel erstellt und deren Inhalt durch KI-Prompts entsprechend umgeschrieben.",
    "toolbar.liquidContent.error": "Beim Generieren der Liquid-Varianten ist ein Fehler aufgetreten. Bitte erneut versuchen.",
    "toolbar.liquidContent.format": "Format",
    "toolbar.liquidContent.format.none": "Keine",
    "toolbar.liquidContent.format.qa": "Q&A",
    "toolbar.liquidContent.format.short": "Paraphrase",
    "toolbar.liquidContent.format.source": "Quellenartikel",
    "toolbar.liquidContent.tenants": "Mandanten",
    "toolbar.liquidContent.title": "Liquid-Content",
    "toolbar.liquidContent.tooltip": "Eine andere Person hat bereits die Erstellung von Liquid-Varianten ausgelöst. Sobald diese fertig sind, werden sie in diesem Tab angezeigt.",
    "toolbar.otherAiTools.description": "Die folgenden Tools sind noch nicht in Unity implementiert, können aber bereits in der Tamedia Toolbox genutzt werden. Ein Klick auf den Link öffnet die Toolbox in einem neuen Tab und startet die Generation. Wichtig: Es kann sein, dass sich die Tools noch in der Testphase befinden.",
    "toolbar.otherAiTools.title": "Andere KI-Tools",
    "toolbar.otherAiTools.toolNames.datawrapperHelper": "Zum Datawrapper Helper",
    "toolbar.otherAiTools.toolNames.printTeaser": "Generiere einen Print-Anriss",
    "toolbar.otherAiTools.toolNames.pushMessage": "Generiere eine Push-Nachricht",
    "toolbar.otherAiTools.toolNames.translation": "Artikel übersetzen",
    "toolbar.revisions.by": "von",
    "toolbar.revisions.created": "Erstellt",
    "toolbar.revisions.restore": "Wiederherstellen",
    "toolbar.revisions.revision": "Revision",
    "toolbar.revisions.title": "Revisionen",
    "toolbar.seoChecker.error": "Ein Fehler ist aufgetreten",
    "toolbar.seoChecker.googleTrendsSuggestions": "Vorschläge auf Google-Trends",
    "toolbar.seoChecker.grade.bad": "Ungenügend",
    "toolbar.seoChecker.grade.fantastic": "Fantastisch",
    "toolbar.seoChecker.grade.good": "Gut",
    "toolbar.seoChecker.grade.okay": "Genügend",
    "toolbar.seoChecker.grade.veryGood": "Sehr gut",
    "toolbar.seoChecker.header": "SEO-Auswertung",
    "toolbar.seoChecker.keywords": "Die fünf Haupt-Keywords für diesen Text sind:",
    "toolbar.seoChecker.keywordsMissing.shortArticle": "Die SEO-Prüfung kann nicht ohne Keywords durchgeführt werden. Diese werden automatisch generiert, wenn der Artikeltext 150 Zeichen unter seiner Ziellänge liegt. Sollte dies nicht der Fall sein, können die Keywords manuell in der SEO-Teaser-Karte im Publikation-Tab generiert werden. Dazu den Button «Keywords generieren» klicken.",
    "toolbar.seoChecker.keywordsMissing.specialLength": "Da für diesen Artikel Special Length als Ziel festgelegt ist, werden für ihn keine Keywords automatisch generiert. Um die SEO-Prüfung zu starten, können die Keywords manuell in der SEO-Teaser-Karte im Publikation-Tab generiert werden. Dazu den Button «Keywords generieren» klicken.",
    "toolbar.seoChecker.keywordsMissing.title": "Keywords fehlen - bitte generieren",
    "toolbar.seoChecker.title": "SEO-Helper",
    "toolbar.spellChecker.congratulations": "Glückwunsch!",
    "toolbar.spellChecker.description1": "Sie sind im Editor <red>rot</red> (Rechtschreibung), <green>grün</green> (Grammatik), <blue>blau</blue> (Typographie) oder <orange>orange</orange> (sonstige) unterstrichen.",
    "toolbar.spellChecker.description2": "Sie können korrigiert werden, indem die unterstrichenen Wörter angeklickt und eine Alternative ausgewählt oder die erforderliche Korrektur direkt eingeben wird.",
    "toolbar.spellChecker.description3": "Die Rechtschreibung kann mit der Tastenkombination<pre> Ctrl + Shift + A </pre>oder durch schliessen des Fensters aktiviert und deaktiviert werden.",
    "toolbar.spellChecker.error": "Ein Fehler ist aufgetreten",
    "toolbar.spellChecker.errorsReported": "... Fehler in diesem Text gefunden",
    "toolbar.spellChecker.evaluatingText": "Der Text wird überprüft",
    "toolbar.spellChecker.noErrors": "Dieser Inhalt enthält keine Fehler",
    "toolbar.spellChecker.title": "Rechtschreibprüfung",
    "toolbar.spellChecker.wait": "Bitte warten",
    "toolbar.teaserGenerator.apply": "Vorschlag übernehmen",
    "toolbar.teaserGenerator.error": "Ein Fehler ist aufgetreten",
    "toolbar.teaserGenerator.error.unknown": "Ein unbekannter Fehler ist aufgetreten",
    "toolbar.teaserGenerator.fewerProposals": "Es konnten nicht alle {{numOfProposals}} Vorschläge generiert werden",
    "toolbar.teaserGenerator.intro": "Generiere Vorschläge für drei verschiedene Teaser basierend auf dem aktuellen Text des Artikels. Nur geeignet für Agentur- oder Gemeindemeldungen.",
    "toolbar.teaserGenerator.introBold": "Der Vorschlag muss zwingend inhaltlich wie stilistisch überprüft werden. Wende Dich bei Fragen an #ai_lab_infos",
    "toolbar.teaserGenerator.proposal": "Vorgeschlagener Teaser",
    "toolbar.teaserGenerator.propose": "Teaser vorschlagen",
    "toolbar.teaserGenerator.proposeButton.tooltip": "Für einen leeren Artikel können keine Teaser-Vorschläge generiert werden.",
    "toolbar.teaserGenerator.refresh": "Neu generieren",
    "toolbar.teaserGenerator.retry": "Erneut versuchen",
    "toolbar.teaserGenerator.title": "Teaser-Vorschläge",
    "toolbar.teaserGenerator.wait": "Einen Moment",
    "toolbar.teaserGenerator.waitDescription": "Teaser werden generiert",
    "toolbar.translation.directionToFrench": "Deutsch → Französisch",
    "toolbar.translation.directionToGerman": "Französisch → Deutsch",
    "toolbar.translation.emptyArticle": "Der Artikel enthält keinen Text zum Übersetzen.",
    "toolbar.translation.failed": "Die Übersetzung ist fehlgeschlagen.",
    "toolbar.translation.introToFrench": "Die Übersetzung wird als neuer Artikel in der französischen Version erstellt.",
    "toolbar.translation.introToGerman": "Die Übersetzung wird als neuer Artikel in der deutschen Version erstellt.",
    "toolbar.translation.openArticle": "Artikel öffnen",
    "toolbar.translation.pendingHint": "Das kann einige Minuten dauern. Du kannst weiterarbeiten – das Ergebnis erscheint hier.",
    "toolbar.translation.pendingIntoFrench": "Übersetzung ins Französische…",
    "toolbar.translation.pendingIntoGerman": "Übersetzung ins Deutsche…",
    "toolbar.translation.submit": "Übersetzen",
    "toolbar.translation.success": "Der Artikel wurde übersetzt.",
    "toolbar.translation.title": "Übersetzung",
    "toolbar.translation.translateAgain": "Erneut übersetzen",
    "toolbar.translation.tryAgain": "Erneut versuchen",
    "toolbar.translation.unsavedChanges": "Die Übersetzung verwendet die zuletzt gespeicherte Version – speichere zuerst deine Änderungen.",
    "toolbar.userNeeds.depth": "Tiefe",
    "toolbar.userNeeds.depth.description": "Gib mir Einordnung und Hintergrund",
    "toolbar.userNeeds.distract": "Auszeit",
    "toolbar.userNeeds.distract.description": "Unterhalte mich",
    "toolbar.userNeeds.facts": "Fakten",
    "toolbar.userNeeds.facts.description": "Gib mir das Wichtigste",
    "toolbar.userNeeds.inspiration": "Emotion",
    "toolbar.userNeeds.inspiration.description": "Berühre und inspiriere mich",
    "toolbar.userNeeds.justification": "Begründung",
    "toolbar.userNeeds.none.description": "User-Need-Analyse für diesen Artikel ist ausstehend. Die Analyse startet automatisch wenn der Artikeltext 150 Zeichen unter seiner Ziellänge liegt oder manuell per Klick auf den Button unten.",
    "toolbar.userNeeds.none.name": "Kein",
    "toolbar.userNeeds.none.targetDescription": "Kein User Need geplant. Du kannst einen User Need auf der Publikationsseite unter Planung setzen.",
    "toolbar.userNeeds.service": "Service",
    "toolbar.userNeeds.service.description": "Gib mir Tipps und Anleitung",
    "toolbar.userNeeds.startAnalysis": "Analyse starten",
    "toolbar.userNeeds.startAnalysis.disabled.blankOrDirty.tooltip": "Die Analyse kann erst gestartet werden, wenn der Artikel gespeichert und sein Inhalt nicht leer ist.",
    "toolbar.userNeeds.startAnalysis.disabled.otherUserGenerating.tooltip": "Eine andere Person hat bereits die User-Need-Analyse ausgelöst. Sobald diese fertig ist, wird sie in diesem Tab angezeigt.",
    "toolbar.userNeeds.startAnalysis.tooltip": "Jeder Artikel sollte klar auf ein User Need fokussiert geschrieben sein, um die Bedürfnisse der Lesenden bestmöglich zu erfüllen. <spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1l64sYj9u8IyCS0moxdcA6_GSOU5nbVJD5wRb8QqEioU/edit?usp=sharing'>Tamedia User Needs Modell</linkComponent",
    "toolbar.userNeeds.title": "User need",
    "toolbar.userNeeds.title.description": "Basierend auf Inhaltsanalyse:",
    "toolbar.userNeeds.title.targetDescription": "Geplant:",
    "user.firstName": "Vorname",
    "user.fullName": "Name",
    "user.id": "User-ID",
    "user.jobTitle": "Job Titel",
    "user.lastName": "Nachname",
    "user.list.addButton": "Externen Account hinzufügen",
    "user.list.tab.all": "Alle",
    "user.list.tab.external": "Extern",
    "user.list.tab.internal": "Intern",
    "user.longBiography": "Lange Biografie",
    "user.prolitterisId": "Prolitteris-ID",
    "user.shortBiography": "Kurze Biografie",
    "user.shortName": "Kürzel",
    "user.twitterHash": "X Username",
    "user.userImage": "Profilbild",
    "userForm.editButton": "Bearbeiten",
    "userForm.oktaAccount": "Okta Account",
    "userForm.title.create": "Profil erstellen",
    "userForm.title.edit": "Profil",
    "userForm.title.tooltip": "Die Kurzbiografie wird unter den Artikeln angezeigt, sie hat eine maximale Länge von 180 Zeichen. Die lange Biografie wird auf der Autorenseite angezeigt (keine maximale Länge). Die Biografien müssen mit dem Namen beginnen, dieser muss gefettet sein: Nachname Name [...Text...]. Das Bild muss quadratisch sein (ideal: 350x350 Pixel).<spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1GRG9Yepz2Wd3Fgis8jtn667hKdsXeZiL0QSFSxPqtco/edit#heading=h.xwd4tgju1cqk'>Die Anleitung mit mehr Details.</linkComponent>",
    "users.list.title": "Accounts",
    "userSettings.betaFeaturesEnabled.label": "Beta Features anzeigen",
    "userSettings.language.deCh": "Deutsch",
    "userSettings.language.enGb": "English",
    "userSettings.language.frCh": "Français",
    "userSettings.title": "Einstellungen",
    "userSettings.uiLocale": "Sprache Benutzeroberfläche",
    "userSettings.uiLocaleDescription": "Diese Einstellung beeinflusst die Sprache der Benutzeroberfläche wie z.B. Überschriften und Buttons.",
    "validate.team.teamsCollision": "Bitte wähle zwei unterschiedliche Teams",
    "validator.message.date": "Ungültiges Datum angegeben",
    "validator.message.deepLink": "Bitte gib eine gültige URL ein",
    "validator.message.hexadecimalColor": "Hex-Farbcode erforderlich (z. B. #DDEE55)",
    "validator.message.insecureUrl": "Bitte gib eine gültige URL ein",
    "validator.message.invalidEmbedCode": "Ungültiger Embed Code",
    "validator.message.invalidFrontendComponentUrl": "Ungültige URL. Sie muss \"tagesanzeiger.ch\" enthalten.",
    "validator.message.invalidJson": "Ungültiges JSON",
    "validator.message.invalidJsonObject": "JSON muss ein Objekt sein",
    "validator.message.invalidProlitterisId": "Maximal {{maxLength}} Zahlen lang",
    "validator.message.invalidTimeFormat": "Ungültige Zeit angegeben",
    "validator.message.invalidTwitteUsername": "Erlaubte Zeichen: \"a-z\", \"0-9\", \"_\" und maximal 15 Zeichen",
    "validator.message.isNotFutureDate": "Datum muss in der Zukunft liegen",
    "validator.message.isPastDate": "Datum kann nicht in der Vergangenheit liegen",
    "validator.message.isPastTime": "Zeit kann nicht in der Vergangenheit liegen",
    "validator.message.livestreamVideoCmsError": "Ungültiger livestream VideoCms Embed Code",
    "validator.message.maxLength": "Maximal {{maxLength}} Zeichen lang",
    "validator.message.minLength": "Mindestens {{minLength}} Zeichen lang",
    "validator.message.noInternalUrl": "Interne URLs nicht erlaubt",
    "validator.message.numbersOnly": "Nur Zahlen erlaubt",
    "validator.message.oneIframeOrUrl": "Bitte gib eine valide und sichere URL (https), oder ein richtig formatiertes iframe (<iframe></iframe> mit https) ein.",
    "validator.message.oneIframeUrlOrEmbedCode": "Bitte gib eine valide und sichere URL (https), ein richtig formatiertes iframe (<iframe></iframe> mit https) ein, oder einen von unity unterstützten Embed Code.",
    "validator.message.path": "Path cannot contain symbols like :",
    "validator.message.required": "Erforderlich",
    "validator.message.secureUrl": "Bitte gib eine sichere (https) und gültige URL ein",
    "validator.message.secureUrlOrMailto": "Gib bitte eine sichere URL (https) ein oder verwende einen gültigen 'mailto:' Link",
    "validator.message.startWithSlash": "Path must start with /",
    "validator.message.validUrlOrEmbedCode": "Gib bitte eine gültige URL ein oder verwende einen gültigen Embed Code",
    "validator.message.validUrlOrMailto": "Gib bitte eine gültige URL ein oder verwende einen gültigen 'mailto:' Link",
    "validator.message.videoCmsError": "Ungültiger VideoCms Embed Code",
    "validator.message.videoCmsVideoIdError": "Fehlende Video-Id im Embed Code",
    "validator.message.weightRange": "Muss zwischen 0 und 1 liegen",
    "validator.notificationCategories.atLeastOneCategoryPerTenant": "Wähle bitte min. eine Kategorie für {{ tenantNames }} aus.",
    "validators.urlSlug.allowedChars": "Erlaubte Zeichen: \"a-z\", \"0-9\" und \"-\"",
    "validators.urlSlug.alreadyTaken": "Dieser Pfad ist bereits vergeben.",
    "variants.selection.edit": "Varianten wechseln",
    "versionUsed": "Unity Frontend Version in Verwendung: {{version}}",
    "video.form.intro": "Intro",
    "video.form.lead": "Lead",
    "video.form.title": "Titel",
    "video.form.titleHeader": "Oberzeile",
    "video.form.video": "Video",
    "video.setup.pageTitle": "Neue Video",
    "videoUpload.error.noPreviewImage": "Bitte warte, bis das Video-Vorschaubild hochgeladen ist",
    "workflowChecklist": "Checkliste",
    "workflowChecklist.noChanges": "Bisher keine Änderungen für diese Aufgabe",
    "workflowChecklist.photoeditingDone": "Bildredaktion",
    "workflowChecklist.productionDone": "Produktion",
    "workflowChecklist.proofreadingDone": "Korrektorat",
    "workflowChecklist.seoDone": "SEO",
    "workflowChecklist.spellcheckingDone": "Rechtschreibprüfung",
    "workflowChecklist.spellcheckingDone.disabled": "Öffne die Rechtschreibprüfung, um dieses Kästchen zu aktualisieren"
}
